{
 "CN": {
  "pos4": {
   "description": "6-4 digit postcode area",
   "z_min": 3
  },
  "bounds": [
   73.5013,
   7.3643,
   134.7734,
   53.5604
  ],
  "feature_id": 3084336,
  "pos1": {
   "description": "2-digit postcode area",
   "z_min": 1
  },
  "adm1": {
   "description": "province",
   "z_min": 0
  },
  "pos2": {
   "description": "3-digit postcode area",
   "z_min": 2
  },
  "pos3": {
   "description": "4-digit postcode area",
   "z_min": 2
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm3": {
   "description": "county",
   "z_min": 2
  },
  "adm2": {
   "description": "sub-prefecture",
   "z_min": 1
  }
 },
 "IN": {
  "pos4": {
   "description": "6-digit postcode area",
   "z_min": 4
  },
  "bounds": [
   68.1745,
   6.756,
   97.3954,
   35.6733
  ],
  "feature_id": 6885481,
  "pos1": {
   "description": "2-digit postcode area",
   "z_min": 1
  },
  "adm1": {
   "description": "state",
   "z_min": 0
  },
  "pos2": {
   "description": "3-digit postcode area",
   "z_min": 2
  },
  "pos3": {
   "description": "4-digit postcode area",
   "z_min": 3
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm3": {
   "description": "subdistrict",
   "z_min": 3
  },
  "adm2": {
   "description": "district",
   "z_min": 1
  }
 },
 "KR": {
  "pos4": {
   "description": "5-digit postcode area",
   "z_min": 6
  },
  "bounds": [
   124.6098,
   33.1129,
   131.8728,
   38.6146
  ],
  "feature_id": 13766778,
  "adm1": {
   "description": "special autonomous province",
   "z_min": 0
  },
  "pos2": {
   "description": "2-digit postcode area",
   "z_min": 3
  },
  "pos3": {
   "description": "3-digit postcode area",
   "z_min": 4
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm3": {
   "description": "neighbourhood",
   "z_min": 6
  },
  "adm2": {
   "description": "city",
   "z_min": 2
  }
 },
 "PH": {
  "pos4": {
   "description": "4-digit postcode area",
   "z_min": 5
  },
  "bounds": [
   114.2779,
   4.5873,
   126.6049,
   21.1219
  ],
  "feature_id": 16584881,
  "adm4": {
   "description": "barangay",
   "z_min": 7
  },
  "adm1": {
   "description": "region",
   "z_min": 0
  },
  "pos3": {
   "description": "2-digit postcode area",
   "z_min": 2
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm3": {
   "description": "municipality",
   "z_min": 3
  },
  "adm2": {
   "description": "province",
   "z_min": 1
  }
 },
 "RU": {
  "pos4": {
   "description": "6-2-digit postcode area",
   "z_min": 3
  },
  "bounds": [
   -540,
   41.1853,
   -169.6584,
   81.8574
  ],
  "feature_id": 12128447,
  "sta1": {
   "description": "federal district",
   "z_min": 0
  },
  "adm1": {
   "description": "autonomous oblast",
   "z_min": 0
  },
  "pos3": {
   "description": "2-digit postcode area",
   "z_min": 0
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm3": {
   "description": "city district",
   "z_min": 3
  },
  "adm2": {
   "description": "urban district",
   "z_min": 2
  }
 },
 "UA": {
  "pos4": {
   "description": "3-5 digit postcode area",
   "z_min": 5
  },
  "bounds": [
   22.1376,
   44.3866,
   40.2256,
   52.3794
  ],
  "feature_id": 15470822,
  "adm1": {
   "description": "region",
   "z_min": 0
  },
  "pos2": {
   "description": "2-digit postcode area",
   "z_min": 2
  },
  "pos3": {
   "description": "3-digit postcode area",
   "z_min": 3
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm2": {
   "description": "district",
   "z_min": 1
  }
 },
 "FK": {
  "pos4": {
   "description": "7-digit postcode area",
   "z_min": 2
  },
  "bounds": [
   -61.4563,
   -52.9191,
   -57.7147,
   -50.9967
  ],
  "feature_id": 4853832,
  "adm1": {
   "description": "territory",
   "z_min": 3
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  }
 },
 "GS": {
  "pos4": {
   "description": "7-digit postcode area",
   "z_min": 2
  },
  "bounds": [
   -42.2024,
   -59.4855,
   -26.2675,
   -53.3417
  ],
  "feature_id": 13701210,
  "adm1": {
   "description": "territory",
   "z_min": 0
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  }
 },
 "AD": {
  "pos4": {
   "description": "5-digit postcode area",
   "z_min": 5
  },
  "bounds": [
   1.4136,
   42.4287,
   1.7865,
   42.6549
  ],
  "feature_id": 331777,
  "adm1": {
   "description": "parish",
   "z_min": 5
  },
  "pos3": {
   "description": "2-digit postcode area",
   "z_min": 1
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  }
 },
 "AL": {
  "pos4": {
   "description": "4-digit postcode area",
   "z_min": 7
  },
  "bounds": [
   19.2635,
   39.6449,
   21.0569,
   42.6603
  ],
  "feature_id": 135174,
  "sta3": {
   "description": "NUTS 3",
   "z_min": 2
  },
  "sta1": {
   "description": "NUTS 1",
   "z_min": 0
  },
  "adm1": {
   "description": "county",
   "z_min": 2
  },
  "pos3": {
   "description": "2-digit postcode area",
   "z_min": 2
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm2": {
   "description": "municipality",
   "z_min": 3
  },
  "sta2": {
   "description": "NUTS 2",
   "z_min": 1
  }
 },
 "AR": {
  "pos4": {
   "description": "5-digit postcode area",
   "z_min": 4
  },
  "bounds": [
   -73.5653,
   -55.0572,
   -53.6374,
   -21.7815
  ],
  "feature_id": 659466,
  "adm1": {
   "description": "province",
   "z_min": 0
  },
  "pos2": {
   "description": "2-digit postcode area",
   "z_min": 2
  },
  "pos3": {
   "description": "3-digit postcode area",
   "z_min": 3
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm2": {
   "description": "department",
   "z_min": 1
  }
 },
 "AS": {
  "pos4": {
   "description": "5-digit postcode area",
   "z_min": 3
  },
  "bounds": [
   -171.09,
   -14.5698,
   -168.1303,
   -11.0479
  ],
  "feature_id": 266251,
  "sta3": {
   "description": "tract",
   "z_min": 4
  },
  "adm1": {
   "description": "territory",
   "z_min": 0
  },
  "pos3": {
   "description": "2-digit postcode area",
   "z_min": 0
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm3": {
   "description": "county",
   "z_min": 3
  },
  "sta4": {
   "description": "block group",
   "z_min": 6
  },
  "adm2": {
   "description": "district",
   "z_min": 3
  }
 },
 "AT": {
  "pos4": {
   "description": "4-digit postcode area",
   "z_min": 6
  },
  "bounds": [
   9.5307,
   46.3723,
   17.1608,
   49.0205
  ],
  "feature_id": 921612,
  "sta3": {
   "description": "NUTS 3",
   "z_min": 2
  },
  "sta1": {
   "description": "NUTS 1",
   "z_min": 0
  },
  "adm4": {
   "description": "cadastral community",
   "z_min": 7
  },
  "adm1": {
   "description": "state",
   "z_min": 1
  },
  "pos3": {
   "description": "2-digit postcode area",
   "z_min": 2
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm3": {
   "description": "district",
   "z_min": 6
  },
  "adm2": {
   "description": "district",
   "z_min": 2
  },
  "sta2": {
   "description": "NUTS 2",
   "z_min": 1
  }
 },
 "AU": {
  "pos4": {
   "description": "4-digit postcode area",
   "z_min": 2
  },
  "bounds": [
   112.9211,
   -54.778,
   159.1092,
   -9.1422
  ],
  "feature_id": 856077,
  "sta3": {
   "description": "statistical areas level 3",
   "z_min": 1
  },
  "sta1": {
   "description": "state and territory",
   "z_min": 0
  },
  "adm1": {
   "description": "territory",
   "z_min": 0
  },
  "sta5": {
   "description": "statistical areas level 1",
   "z_min": 5
  },
  "pos3": {
   "description": "2-digit postcode area",
   "z_min": 0
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "sta4": {
   "description": "statistical areas level 2",
   "z_min": 2
  },
  "adm2": {
   "description": "local government area",
   "z_min": 1
  },
  "sta2": {
   "description": "statistical areas level 4",
   "z_min": 0
  }
 },
 "AX": {
  "pos4": {
   "description": "5-digit postcode area",
   "z_min": 4
  },
  "bounds": [
   19.2633,
   59.7333,
   21.3303,
   60.6657
  ],
  "feature_id": 65998863,
  "sta3": {
   "description": "NUTS 3",
   "z_min": 2
  },
  "sta1": {
   "description": "NUTS 1",
   "z_min": 0
  },
  "adm1": {
   "description": "region",
   "z_min": 1
  },
  "pos3": {
   "description": "2-digit postcode area",
   "z_min": 2
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm3": {
   "description": "municipality",
   "z_min": 3
  },
  "adm2": {
   "description": "sub-regional unit",
   "z_min": 2
  },
  "sta2": {
   "description": "NUTS 2",
   "z_min": 1
  }
 },
 "BA": {
  "pos4": {
   "description": "5-digit postcode area",
   "z_min": 5
  },
  "bounds": [
   15.7212,
   42.5605,
   19.6235,
   45.2764
  ],
  "feature_id": 1839121,
  "sta3": {
   "description": "NUTS 3",
   "z_min": 2
  },
  "sta1": {
   "description": "NUTS 1",
   "z_min": 0
  },
  "adm1": {
   "description": "region",
   "z_min": 1
  },
  "pos3": {
   "description": "2-digit postcode area",
   "z_min": 2
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm3": {
   "description": "municipality",
   "z_min": 3
  },
  "adm2": {
   "description": "region",
   "z_min": 2
  },
  "sta2": {
   "description": "NUTS 2",
   "z_min": 1
  }
 },
 "BE": {
  "pos4": {
   "description": "4-digit postcode area",
   "z_min": 5
  },
  "bounds": [
   2.5454,
   49.497,
   6.4082,
   51.5051
  ],
  "feature_id": 1380372,
  "sta3": {
   "description": "NUTS 3",
   "z_min": 2
  },
  "sta1": {
   "description": "NUTS 1",
   "z_min": 0
  },
  "adm4": {
   "description": "municipality",
   "z_min": 5
  },
  "adm1": {
   "description": "region",
   "z_min": 1
  },
  "pos3": {
   "description": "2-digit postcode area",
   "z_min": 3
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm3": {
   "description": "district",
   "z_min": 3
  },
  "adm2": {
   "description": "province",
   "z_min": 1
  },
  "sta2": {
   "description": "NUTS 2",
   "z_min": 1
  }
 },
 "BG": {
  "pos4": {
   "description": "4-digit postcode area",
   "z_min": 6
  },
  "bounds": [
   22.3564,
   41.2354,
   28.6119,
   44.2153
  ],
  "feature_id": 2297878,
  "sta3": {
   "description": "NUTS 3",
   "z_min": 1
  },
  "sta1": {
   "description": "NUTS 1",
   "z_min": 0
  },
  "adm1": {
   "description": "province",
   "z_min": 1
  },
  "pos3": {
   "description": "2-digit postcode area",
   "z_min": 2
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm2": {
   "description": "municipality",
   "z_min": 3
  },
  "sta2": {
   "description": "NUTS 2",
   "z_min": 0
  }
 },
 "BH": {
  "pos4": {
   "description": "4-digit postcode area",
   "z_min": 4
  },
  "bounds": [
   50.3152,
   25.5717,
   50.8245,
   26.4229
  ],
  "feature_id": 1118231,
  "adm1": {
   "description": "governorate",
   "z_min": 0
  },
  "pos3": {
   "description": "2-digit postcode area",
   "z_min": 3
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm3": {
   "description": "block",
   "z_min": 2
  },
  "adm2": {
   "description": "area",
   "z_min": 1
  }
 },
 "BL": {
  "pos4": {
   "description": "5-digit postcode area",
   "z_min": 2
  },
  "bounds": [
   -62.9104,
   17.8782,
   -62.7891,
   17.9609
  ],
  "feature_id": 12259354,
  "adm1": {
   "description": "municipality",
   "z_min": 1
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  }
 },
 "BM": {
  "pos4": {
   "description": "4-digit postcode area",
   "z_min": 2
  },
  "bounds": [
   -64.8875,
   32.2472,
   -64.647,
   32.391
  ],
  "feature_id": 1576987,
  "adm1": {
   "description": "territory",
   "z_min": 0
  },
  "pos3": {
   "description": "2-digit postcode area",
   "z_min": 2
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm2": {
   "description": "parish",
   "z_min": 2
  }
 },
 "BR": {
  "pos4": {
   "description": "5-2-digit postcode area",
   "z_min": 4
  },
  "bounds": [
   -73.9832,
   -33.7512,
   -28.8478,
   5.2695
  ],
  "feature_id": 2035743,
  "sta3": {
   "description": "microregion",
   "z_min": 2
  },
  "sta1": {
   "description": "state",
   "z_min": 0
  },
  "adm1": {
   "description": "federal district",
   "z_min": 0
  },
  "pos3": {
   "description": "2-digit postcode area",
   "z_min": 3
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm2": {
   "description": "federal district",
   "z_min": 3
  },
  "sta2": {
   "description": "mesoregion",
   "z_min": 1
  }
 },
 "BY": {
  "pos4": {
   "description": "6-digit postcode area",
   "z_min": 5
  },
  "bounds": [
   23.1783,
   51.2322,
   32.7763,
   56.1721
  ],
  "feature_id": 1314852,
  "adm1": {
   "description": "region",
   "z_min": 0
  },
  "pos3": {
   "description": "2-digit postcode area",
   "z_min": 0
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm2": {
   "description": "district",
   "z_min": 1
  }
 },
 "CA": {
  "pos4": {
   "description": "6-digit postcode area",
   "z_min": 9
  },
  "bounds": [
   -141.0105,
   41.6814,
   -52.6194,
   83.1355
  ],
  "feature_id": 2691110,
  "sta3": {
   "description": "unorganized",
   "z_min": 4
  },
  "leg2": {
   "description": "federal electoral districts",
   "z_min": 1
  },
  "leg1": {
   "description": "Senate",
   "z_min": 0
  },
  "leg3": {
   "description": "electoral divisions",
   "z_min": 2
  },
  "sta1": {
   "description": "province",
   "z_min": 0
  },
  "adm1": {
   "description": "province",
   "z_min": 0
  },
  "pos3": {
   "description": "3-digit postcode area",
   "z_min": 2
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "sta2": {
   "description": "census division",
   "z_min": 1
  }
 },
 "CH": {
  "pos4": {
   "description": "4-digit postcode area",
   "z_min": 4
  },
  "bounds": [
   5.9559,
   45.818,
   10.4921,
   47.8085
  ],
  "feature_id": 14356523,
  "sta3": {
   "description": "NUTS 3",
   "z_min": 2
  },
  "sta1": {
   "description": "NUTS 1",
   "z_min": 0
  },
  "adm1": {
   "description": "canton",
   "z_min": 0
  },
  "pos3": {
   "description": "2-digit postcode area",
   "z_min": 2
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm3": {
   "description": "municipality",
   "z_min": 6
  },
  "adm2": {
   "description": "district",
   "z_min": 2
  },
  "sta2": {
   "description": "NUTS 2",
   "z_min": 1
  }
 },
 "CO": {
  "pos4": {
   "description": "6-digit postcode area",
   "z_min": 3
  },
  "bounds": [
   -81.7356,
   -4.2273,
   -66.8465,
   13.3947
  ],
  "feature_id": 3477553,
  "adm1": {
   "description": "department",
   "z_min": 0
  },
  "pos2": {
   "description": "2-digit postcode area",
   "z_min": 2
  },
  "pos3": {
   "description": "4-digit postcode area",
   "z_min": 3
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm2": {
   "description": "municipality",
   "z_min": 2
  }
 },
 "CR": {
  "pos4": {
   "description": "5-digit postcode area",
   "z_min": 5
  },
  "bounds": [
   -87.102,
   5.4991,
   -82.5514,
   11.2197
  ],
  "feature_id": 3739698,
  "adm1": {
   "description": "province",
   "z_min": 0
  },
  "pos3": {
   "description": "3-digit postcode area",
   "z_min": 3
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm3": {
   "description": "district",
   "z_min": 5
  },
  "adm2": {
   "description": "canton",
   "z_min": 4
  }
 },
 "CY": {
  "pos4": {
   "description": "4-digit postcode area",
   "z_min": 6
  },
  "bounds": [
   32.2692,
   34.6323,
   34.6066,
   35.7109
  ],
  "feature_id": 16650295,
  "sta3": {
   "description": "NUTS 3",
   "z_min": 2
  },
  "sta1": {
   "description": "nuts 1",
   "z_min": 0
  },
  "adm1": {
   "description": "district",
   "z_min": 0
  },
  "pos3": {
   "description": "2-digit postcode area",
   "z_min": 3
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm2": {
   "description": "community",
   "z_min": 4
  },
  "sta2": {
   "description": "nuts 2",
   "z_min": 1
  }
 },
 "CZ": {
  "pos4": {
   "description": "5-digit postcode area",
   "z_min": 5
  },
  "bounds": [
   12.0906,
   48.5518,
   18.8592,
   51.0557
  ],
  "feature_id": 4001848,
  "sta3": {
   "description": "NUTS 3",
   "z_min": 2
  },
  "sta1": {
   "description": "NUTS 1",
   "z_min": 0
  },
  "adm1": {
   "description": "region",
   "z_min": 0
  },
  "pos3": {
   "description": "2-digit postcode area",
   "z_min": 2
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm3": {
   "description": "municipality",
   "z_min": 6
  },
  "adm2": {
   "description": "district",
   "z_min": 2
  },
  "loc1": {
   "description": "orp",
   "z_min": 0
  },
  "sta2": {
   "description": "NUTS 2",
   "z_min": 1
  }
 },
 "DE": {
  "pos4": {
   "description": "5-digit postcode area",
   "z_min": 5
  },
  "bounds": [
   5.8663,
   47.2702,
   15.0418,
   55.0568
  ],
  "feature_id": 5574713,
  "sta3": {
   "description": "NUTS 3",
   "z_min": 2
  },
  "pos1": {
   "description": "1-digit postcode area",
   "z_min": 1
  },
  "sta1": {
   "description": "NUTS 1",
   "z_min": 0
  },
  "adm1": {
   "description": "federal state",
   "z_min": 0
  },
  "pos2": {
   "description": "2-digit postcode area",
   "z_min": 2
  },
  "pos3": {
   "description": "postal directing area",
   "z_min": 3
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm3": {
   "description": "municipality",
   "z_min": 6
  },
  "adm2": {
   "description": "rural district",
   "z_min": 2
  },
  "sta2": {
   "description": "NUTS 2",
   "z_min": 1
  }
 },
 "DK": {
  "pos4": {
   "description": "4-digit postcode area",
   "z_min": 5
  },
  "bounds": [
   8.0725,
   54.5591,
   15.1974,
   57.7522
  ],
  "feature_id": 4132923,
  "sta3": {
   "description": "NUTS 3",
   "z_min": 2
  },
  "sta1": {
   "description": "NUTS 1",
   "z_min": 0
  },
  "adm1": {
   "description": "region",
   "z_min": 0
  },
  "sta5": {
   "description": "LAU 2",
   "z_min": 3
  },
  "pos3": {
   "description": "2-digit postcode area",
   "z_min": 2
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "sta4": {
   "description": "LAU 1",
   "z_min": 2
  },
  "adm2": {
   "description": "municipality",
   "z_min": 1
  },
  "sta2": {
   "description": "NUTS 2",
   "z_min": 1
  }
 },
 "EE": {
  "pos4": {
   "description": "5-digit postcode area",
   "z_min": 6
  },
  "bounds": [
   21.7643,
   57.5093,
   28.2099,
   59.822
  ],
  "feature_id": 4722752,
  "sta3": {
   "description": "NUTS 3",
   "z_min": 2
  },
  "sta1": {
   "description": "NUTS 1",
   "z_min": 0
  },
  "adm1": {
   "description": "county",
   "z_min": 0
  },
  "pos3": {
   "description": "2-digit postcode area",
   "z_min": 2
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm2": {
   "description": "municipality",
   "z_min": 2
  },
  "sta2": {
   "description": "NUTS 2",
   "z_min": 1
  }
 },
 "ES": {
  "pos4": {
   "description": "5-digit postcode area",
   "z_min": 5
  },
  "bounds": [
   -18.1612,
   27.6377,
   4.3278,
   43.7924
  ],
  "feature_id": 13897796,
  "sta3": {
   "description": "NUTS 3",
   "z_min": 2
  },
  "sta1": {
   "description": "NUTS 1",
   "z_min": 0
  },
  "adm1": {
   "description": "autonomous city",
   "z_min": 0
  },
  "pos3": {
   "description": "2-digit postcode area",
   "z_min": 1
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm3": {
   "description": "municipality",
   "z_min": 6
  },
  "adm2": {
   "description": "province",
   "z_min": 1
  },
  "sta2": {
   "description": "NUTS 2",
   "z_min": 1
  }
 },
 "FI": {
  "pos4": {
   "description": "5-digit postcode area",
   "z_min": 4
  },
  "bounds": [
   20.5472,
   59.6761,
   31.5879,
   70.0923
  ],
  "feature_id": 5050438,
  "sta3": {
   "description": "NUTS 3",
   "z_min": 2
  },
  "sta1": {
   "description": "NUTS 1",
   "z_min": 0
  },
  "adm1": {
   "description": "region",
   "z_min": 1
  },
  "pos3": {
   "description": "2-digit postcode area",
   "z_min": 2
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm3": {
   "description": "municipality",
   "z_min": 3
  },
  "adm2": {
   "description": "sub-regional unit",
   "z_min": 2
  },
  "sta2": {
   "description": "NUTS 2",
   "z_min": 1
  }
 },
 "FO": {
  "pos4": {
   "description": "3-digit postcode area",
   "z_min": 5
  },
  "bounds": [
   -7.6919,
   61.3902,
   -6.2536,
   62.3941
  ],
  "feature_id": 4919370,
  "adm1": {
   "description": "territory",
   "z_min": 2
  },
  "pos3": {
   "description": "2-digit postcode area",
   "z_min": 4
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm3": {
   "description": "municipality",
   "z_min": 4
  },
  "adm2": {
   "description": "shire",
   "z_min": 3
  }
 },
 "FR": {
  "pos4": {
   "description": "5-digit postcode area",
   "z_min": 5
  },
  "bounds": [
   -5.143,
   41.3333,
   9.5603,
   51.0891
  ],
  "feature_id": 5115979,
  "sta3": {
   "description": "NUTS 3",
   "z_min": 2
  },
  "leg4": {
   "description": "canton",
   "z_min": 0
  },
  "sta1": {
   "description": "NUTS 1",
   "z_min": 0
  },
  "adm4": {
   "description": "commune",
   "z_min": 6
  },
  "adm1": {
   "description": "region",
   "z_min": 0
  },
  "pos3": {
   "description": "2-digit postcode area",
   "z_min": 2
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm3": {
   "description": "arrondissement",
   "z_min": 2
  },
  "adm2": {
   "description": "department",
   "z_min": 1
  },
  "sta2": {
   "description": "NUTS 2",
   "z_min": 1
  }
 },
 "GB": {
  "pos4": {
   "description": "postcode unit",
   "z_min": 8
  },
  "bounds": [
   -8.6501,
   49.8668,
   1.763,
   60.8608
  ],
  "feature_id": 15601741,
  "sta3": {
   "description": "NUTS 3",
   "z_min": 2
  },
  "pos1": {
   "description": "postcode area",
   "z_min": 2
  },
  "sta1": {
   "description": "NUTS 1",
   "z_min": 0
  },
  "adm1": {
   "description": "country",
   "z_min": 0
  },
  "pos2": {
   "description": "postcode district",
   "z_min": 4
  },
  "pos3": {
   "description": "postcode sector",
   "z_min": 5
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm3": {
   "description": "unitary authority",
   "z_min": 2
  },
  "adm2": {
   "description": "unitary authority",
   "z_min": 1
  },
  "sta2": {
   "description": "NUTS 2",
   "z_min": 1
  }
 },
 "GF": {
  "pos4": {
   "description": "5-digit postcode area",
   "z_min": 2
  },
  "bounds": [
   -54.6024,
   2.1111,
   -51.6291,
   5.7482
  ],
  "feature_id": 5181520,
  "adm4": {
   "description": "commune",
   "z_min": 4
  },
  "adm1": {
   "description": "region",
   "z_min": 0
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm3": {
   "description": "arrondissement",
   "z_min": 2
  },
  "adm2": {
   "description": "department",
   "z_min": 1
  }
 },
 "GI": {
  "pos4": {
   "description": "postcode unit",
   "z_min": 8
  },
  "bounds": [
   -5.3677,
   36.1089,
   -5.3386,
   36.159
  ],
  "feature_id": 5705811,
  "pos1": {
   "description": "postcode area",
   "z_min": 2
  },
  "adm1": {
   "description": "territory",
   "z_min": 0
  },
  "pos2": {
   "description": "postcode district",
   "z_min": 4
  },
  "pos3": {
   "description": "postcode sector",
   "z_min": 5
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  }
 },
 "GL": {
  "pos4": {
   "description": "4-digit postcode area",
   "z_min": 1
  },
  "bounds": [
   -73.2481,
   59.7756,
   -11.4833,
   83.6607
  ],
  "feature_id": 5902420,
  "adm1": {
   "description": "autonomous territory",
   "z_min": 0
  },
  "pos3": {
   "description": "3-digit postcode area",
   "z_min": 0
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm2": {
   "description": "municipality",
   "z_min": 0
  }
 },
 "GP": {
  "pos4": {
   "description": "5-digit postcode area",
   "z_min": 2
  },
  "bounds": [
   -61.8096,
   15.8321,
   -61.002,
   16.5144
  ],
  "feature_id": 6033495,
  "adm4": {
   "description": "commune",
   "z_min": 6
  },
  "adm1": {
   "description": "region",
   "z_min": 0
  },
  "pos3": {
   "description": "2-digit postcode area",
   "z_min": 2
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm3": {
   "description": "arrondissement",
   "z_min": 2
  },
  "adm2": {
   "description": "department",
   "z_min": 1
  }
 },
 "GR": {
  "pos4": {
   "description": "5-digit postcode area",
   "z_min": 3
  },
  "bounds": [
   19.3728,
   34.8006,
   29.6457,
   41.7489
  ],
  "feature_id": 5836889,
  "sta3": {
   "description": "NUTS 3",
   "z_min": 2
  },
  "sta1": {
   "description": "NUTS 1",
   "z_min": 0
  },
  "adm4": {
   "description": "autonomous state",
   "z_min": 2
  },
  "adm1": {
   "description": "autonomous state",
   "z_min": 0
  },
  "sta5": {
   "description": "LAU 2",
   "z_min": 3
  },
  "pos3": {
   "description": "2-digit postcode area",
   "z_min": 2
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm3": {
   "description": "autonomous state",
   "z_min": 1
  },
  "sta4": {
   "description": "LAU1 1",
   "z_min": 3
  },
  "adm2": {
   "description": "periphery",
   "z_min": 0
  },
  "sta2": {
   "description": "NUTS 2",
   "z_min": 1
  }
 },
 "GU": {
  "pos4": {
   "description": "5-digit postcode area",
   "z_min": 6
  },
  "bounds": [
   144.6181,
   13.2338,
   144.9569,
   13.6544
  ],
  "feature_id": 6099036,
  "sta3": {
   "description": "tract",
   "z_min": 0
  },
  "adm1": {
   "description": "territory",
   "z_min": 0
  },
  "pos3": {
   "description": "2-digit postcode area",
   "z_min": 0
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "sta4": {
   "description": "block group",
   "z_min": 6
  },
  "adm2": {
   "description": "village",
   "z_min": 6
  }
 },
 "HR": {
  "pos4": {
   "description": "5-digit postcode area",
   "z_min": 5
  },
  "bounds": [
   13.4898,
   42.3922,
   19.4473,
   46.5549
  ],
  "feature_id": 3805282,
  "sta3": {
   "description": "NUTS 3",
   "z_min": 2
  },
  "sta1": {
   "description": "NUTS 1",
   "z_min": 0
  },
  "adm1": {
   "description": "county",
   "z_min": 1
  },
  "pos3": {
   "description": "2-digit postcode area",
   "z_min": 2
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm2": {
   "description": "municipality",
   "z_min": 4
  },
  "sta2": {
   "description": "NUTS 2",
   "z_min": 1
  }
 },
 "HU": {
  "pos4": {
   "description": "4-digit postcode area",
   "z_min": 6
  },
  "bounds": [
   16.1139,
   45.7372,
   22.8974,
   48.5854
  ],
  "feature_id": 6754404,
  "sta3": {
   "description": "NUTS 3",
   "z_min": 2
  },
  "sta1": {
   "description": "region",
   "z_min": 0
  },
  "adm1": {
   "description": "county",
   "z_min": 1
  },
  "pos3": {
   "description": "2-digit postcode area",
   "z_min": 2
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm3": {
   "description": "municipality",
   "z_min": 6
  },
  "adm2": {
   "description": "district",
   "z_min": 2
  },
  "sta2": {
   "description": "NUTS 2",
   "z_min": 1
  }
 },
 "ID": {
  "pos4": {
   "description": "5-digit postcode area",
   "z_min": 2
  },
  "bounds": [
   95.0105,
   -11.0097,
   141.0296,
   6.0769
  ],
  "feature_id": 6951013,
  "adm4": {
   "description": "Urban Community",
   "z_min": 6
  },
  "adm1": {
   "description": "province",
   "z_min": 0
  },
  "pos3": {
   "description": "2-digit postcode area",
   "z_min": 1
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm3": {
   "description": "District",
   "z_min": 4
  },
  "adm2": {
   "description": "city",
   "z_min": 1
  }
 },
 "IS": {
  "pos4": {
   "description": "3-digit postcode area",
   "z_min": 2
  },
  "bounds": [
   -24.5327,
   63.2958,
   -13.4946,
   66.5664
  ],
  "feature_id": 6819949,
  "sta3": {
   "description": "NUTS 3",
   "z_min": 1
  },
  "sta1": {
   "description": "NUTS 1",
   "z_min": 0
  },
  "adm1": {
   "description": "region",
   "z_min": 0
  },
  "pos3": {
   "description": "2-digit postcode area",
   "z_min": 1
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm2": {
   "description": "municipality",
   "z_min": 2
  },
  "sta2": {
   "description": "NUTS 2",
   "z_min": 1
  }
 },
 "IT": {
  "pos4": {
   "description": "5-digit postcode area",
   "z_min": 5
  },
  "bounds": [
   6.6266,
   35.4929,
   18.5204,
   47.0921
  ],
  "feature_id": 7344238,
  "sta3": {
   "description": "NUTS 3",
   "z_min": 2
  },
  "sta1": {
   "description": "NUTS 1",
   "z_min": 0
  },
  "adm1": {
   "description": "autonomous region",
   "z_min": 0
  },
  "pos3": {
   "description": "2-digit postcode area",
   "z_min": 2
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm3": {
   "description": "municipality",
   "z_min": 6
  },
  "adm2": {
   "description": "province",
   "z_min": 1
  },
  "sta2": {
   "description": "NUTS 2",
   "z_min": 1
  }
 },
 "JP": {
  "pos4": {
   "description": "7-digit postcode area",
   "z_min": 7
  },
  "bounds": [
   122.9338,
   24.0457,
   145.8175,
   45.523
  ],
  "feature_id": 7540850,
  "sta3": {
   "description": "statistical area",
   "z_min": 7
  },
  "pos1": {
   "description": "2-digit postcode area",
   "z_min": 2
  },
  "sta1": {
   "description": "metropolitan area",
   "z_min": 2
  },
  "adm4": {
   "description": "ward",
   "z_min": 5
  },
  "adm1": {
   "description": "prefecture",
   "z_min": 0
  },
  "pos2": {
   "description": "3-digit postcode area",
   "z_min": 3
  },
  "pos3": {
   "description": "5-digit postcode area",
   "z_min": 5
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm3": {
   "description": "town",
   "z_min": 3
  },
  "sta2": {
   "description": "municipality",
   "z_min": 3
  }
 },
 "KW": {
  "pos4": {
   "description": "2-digit postcode area",
   "z_min": 2
  },
  "bounds": [
   46.558,
   28.5235,
   48.7781,
   30.1033
  ],
  "feature_id": 7999611,
  "adm1": {
   "description": "governorate",
   "z_min": 0
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm2": {
   "description": "district",
   "z_min": 1
  }
 },
 "LI": {
  "pos4": {
   "description": "4-digit postcode area",
   "z_min": 4
  },
  "bounds": [
   9.4717,
   47.0484,
   9.6356,
   47.2706
  ],
  "feature_id": 8523905,
  "sta3": {
   "description": "NUTS 3",
   "z_min": 2
  },
  "sta1": {
   "description": "NUTS 1",
   "z_min": 0
  },
  "adm1": {
   "description": "municipality",
   "z_min": 5
  },
  "pos3": {
   "description": "2-digit postcode area",
   "z_min": 2
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "sta2": {
   "description": "NUTS 2",
   "z_min": 1
  }
 },
 "LT": {
  "pos4": {
   "description": "5-digit postcode area",
   "z_min": 6
  },
  "bounds": [
   20.9539,
   53.8988,
   26.8354,
   56.4502
  ],
  "feature_id": 8589445,
  "sta3": {
   "description": "NUTS 3",
   "z_min": 2
  },
  "sta1": {
   "description": "NUTS 1",
   "z_min": 0
  },
  "adm1": {
   "description": "county",
   "z_min": 0
  },
  "pos3": {
   "description": "2-digit postcode area",
   "z_min": 2
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm3": {
   "description": "municipality",
   "z_min": 3
  },
  "adm2": {
   "description": "municipality",
   "z_min": 1
  },
  "sta2": {
   "description": "NUTS 2",
   "z_min": 1
  }
 },
 "LU": {
  "pos4": {
   "description": "4-digit postcode area",
   "z_min": 4
  },
  "bounds": [
   5.7358,
   49.4478,
   6.531,
   50.1827
  ],
  "feature_id": 8654982,
  "sta3": {
   "description": "NUTS 3",
   "z_min": 1
  },
  "sta1": {
   "description": "NUTS 1",
   "z_min": 0
  },
  "adm1": {
   "description": "commune",
   "z_min": 3
  },
  "pos3": {
   "description": "2-digit postcode area",
   "z_min": 2
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "sta4": {
   "description": "canton",
   "z_min": 1
  },
  "sta2": {
   "description": "NUTS 2",
   "z_min": 1
  }
 },
 "LV": {
  "pos4": {
   "description": "4-digit postcode area",
   "z_min": 4
  },
  "bounds": [
   20.9706,
   55.6744,
   28.2422,
   58.0856
  ],
  "feature_id": 8196231,
  "sta3": {
   "description": "NUTS 3",
   "z_min": 2
  },
  "sta1": {
   "description": "NUTS 1",
   "z_min": 0
  },
  "adm1": {
   "description": "county",
   "z_min": 1
  },
  "pos3": {
   "description": "2-digit postcode area",
   "z_min": 1
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm2": {
   "description": "county district",
   "z_min": 3
  },
  "sta2": {
   "description": "NUTS 2",
   "z_min": 1
  }
 },
 "MC": {
  "pos4": {
   "description": "5-digit postcode area",
   "z_min": 3
  },
  "bounds": [
   7.4091,
   43.7247,
   7.44,
   43.7516
  ],
  "feature_id": 9703562,
  "adm1": {
   "description": "commune",
   "z_min": 3
  },
  "pos3": {
   "description": "3-digit postcode area",
   "z_min": 3
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm2": {
   "description": "quartier",
   "z_min": 6
  }
 },
 "MD": {
  "pos4": {
   "description": "4-digit postcode area",
   "z_min": 6
  },
  "bounds": [
   26.6197,
   45.4689,
   30.1628,
   48.4923
  ],
  "feature_id": 9638027,
  "adm1": {
   "description": "district",
   "z_min": 1
  },
  "pos3": {
   "description": "2-digit postcode area",
   "z_min": 2
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm2": {
   "description": "municipality",
   "z_min": 4
  }
 },
 "ME": {
  "pos4": {
   "description": "5-digit postcode area",
   "z_min": 3
  },
  "bounds": [
   18.4354,
   41.8468,
   20.3555,
   43.5518
  ],
  "feature_id": 9834636,
  "sta3": {
   "description": "NUTS 3",
   "z_min": 2
  },
  "sta1": {
   "description": "NUTS 1",
   "z_min": 0
  },
  "adm1": {
   "description": "municipality",
   "z_min": 0
  },
  "pos3": {
   "description": "2-digit postcode area",
   "z_min": 2
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "sta2": {
   "description": "NUTS 2",
   "z_min": 1
  }
 },
 "MF": {
  "pos4": {
   "description": "5-digit postcode area",
   "z_min": 2
  },
  "bounds": [
   -63.1533,
   18.0447,
   -62.9706,
   18.1252
  ],
  "feature_id": 12521613,
  "adm1": {
   "description": "collectivity",
   "z_min": 3
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  }
 },
 "MK": {
  "pos4": {
   "description": "4-digit postcode area",
   "z_min": 6
  },
  "bounds": [
   20.453,
   40.8535,
   23.034,
   42.3741
  ],
  "feature_id": 8720528,
  "sta3": {
   "description": "NUTS 3",
   "z_min": 2
  },
  "sta1": {
   "description": "NUTS 1",
   "z_min": 0
  },
  "adm1": {
   "description": "municipality",
   "z_min": 1
  },
  "pos3": {
   "description": "2-digit postcode area",
   "z_min": 2
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "sta2": {
   "description": "NUTS 2",
   "z_min": 1
  }
 },
 "MP": {
  "pos4": {
   "description": "5-digit postcode areas",
   "z_min": 3
  },
  "bounds": [
   144.8863,
   14.1104,
   146.0648,
   20.5538
  ],
  "feature_id": 10948757,
  "sta3": {
   "description": "tract",
   "z_min": 4
  },
  "adm1": {
   "description": "territory",
   "z_min": 3
  },
  "pos3": {
   "description": "2-digit postcode area",
   "z_min": 0
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "sta4": {
   "description": "block group",
   "z_min": 6
  },
  "adm2": {
   "description": "municipality",
   "z_min": 3
  }
 },
 "MQ": {
  "pos4": {
   "description": "5-digit postcode area",
   "z_min": 3
  },
  "bounds": [
   -61.2293,
   14.3887,
   -60.8095,
   14.8788
  ],
  "feature_id": 9244822,
  "adm4": {
   "description": "commune",
   "z_min": 6
  },
  "adm1": {
   "description": "region",
   "z_min": 0
  },
  "pos3": {
   "description": "2-digit postcode area",
   "z_min": 3
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm3": {
   "description": "arrondissement",
   "z_min": 2
  },
  "adm2": {
   "description": "region",
   "z_min": 1
  }
 },
 "MS": {
  "pos4": {
   "description": "4-digit postcode area",
   "z_min": 2
  },
  "bounds": [
   -62.242,
   16.6744,
   -62.1442,
   16.824
  ],
  "feature_id": 9900184,
  "adm1": {
   "description": "territory",
   "z_min": 1
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm2": {
   "description": "parish",
   "z_min": 2
  }
 },
 "MX": {
  "pos4": {
   "description": "5-2-digit postcode area",
   "z_min": 4
  },
  "bounds": [
   -118.3651,
   14.53,
   -86.7104,
   32.7188
  ],
  "feature_id": 9506973,
  "adm1": {
   "description": "state",
   "z_min": 0
  },
  "pos3": {
   "description": "2-digit postcode area",
   "z_min": 2
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm2": {
   "description": "municipality",
   "z_min": 2
  }
 },
 "MY": {
  "pos4": {
   "description": "5-digit postcode area",
   "z_min": 4
  },
  "bounds": [
   99.6407,
   0.8546,
   119.2697,
   7.3806
  ],
  "feature_id": 8917150,
  "adm1": {
   "description": "federal territory",
   "z_min": 0
  },
  "pos3": {
   "description": "2-digit postcode area",
   "z_min": 2
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm2": {
   "description": "district",
   "z_min": 1
  }
 },
 "NI": {
  "pos4": {
   "description": "3-5-digit postcode areas",
   "z_min": 3
  },
  "bounds": [
   -87.6906,
   10.7094,
   -82.7346,
   15.0294
  ],
  "feature_id": 10555557,
  "adm1": {
   "description": "department",
   "z_min": 0
  },
  "pos2": {
   "description": "1-digit postcode areas",
   "z_min": 1
  },
  "pos3": {
   "description": "2-digit postcode areas",
   "z_min": 1
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm2": {
   "description": "municipality",
   "z_min": 3
  }
 },
 "NL": {
  "pos4": {
   "description": "6-digit postcode area",
   "z_min": 9
  },
  "bounds": [
   3.3584,
   50.7504,
   7.2275,
   53.555
  ],
  "feature_id": 10358950,
  "sta3": {
   "description": "NUTS 3",
   "z_min": 2
  },
  "pos1": {
   "description": "2-digit postcode area",
   "z_min": 2
  },
  "sta1": {
   "description": "NUTS 1",
   "z_min": 0
  },
  "adm1": {
   "description": "province",
   "z_min": 1
  },
  "pos2": {
   "description": "4-digit postcode area",
   "z_min": 6
  },
  "pos3": {
   "description": "5-digit postcode area",
   "z_min": 7
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm2": {
   "description": "municipality",
   "z_min": 3
  },
  "sta2": {
   "description": "NUTS 2",
   "z_min": 1
  }
 },
 "NO": {
  "pos4": {
   "description": "4-digit postcode area",
   "z_min": 4
  },
  "bounds": [
   4.4999,
   57.9594,
   31.1683,
   71.1855
  ],
  "feature_id": 11014311,
  "sta3": {
   "description": "NUTS 3",
   "z_min": 2
  },
  "sta1": {
   "description": "NUTS 1",
   "z_min": 0
  },
  "adm1": {
   "description": "region",
   "z_min": 0
  },
  "pos3": {
   "description": "2-digit postcode area",
   "z_min": 2
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "sta4": {
   "description": "LAU 1",
   "z_min": 2
  },
  "adm2": {
   "description": "municipality",
   "z_min": 2
  },
  "sta2": {
   "description": "NUTS 2",
   "z_min": 1
  }
 },
 "NZ": {
  "pos4": {
   "description": "4-digit postcode area",
   "z_min": 3
  },
  "bounds": [
   165.87,
   -52.6088,
   183.8456,
   -34.1292
  ],
  "feature_id": 10490027,
  "sta3": {
   "description": "statistical area",
   "z_min": 2
  },
  "leg2": {
   "description": "constituency",
   "z_min": 1
  },
  "leg1": {
   "description": "regional council",
   "z_min": 0
  },
  "leg3": {
   "description": "community board",
   "z_min": 2
  },
  "sta1": {
   "description": "urban rural",
   "z_min": 0
  },
  "adm1": {
   "description": "n/a",
   "z_min": 0
  },
  "pos3": {
   "description": "2-digit postcode area",
   "z_min": 2
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm3": {
   "description": "ward",
   "z_min": 2
  },
  "sta4": {
   "description": "meshblock",
   "z_min": 3
  },
  "adm2": {
   "description": "territorial authority",
   "z_min": 1
  },
  "sta2": {
   "description": "statistical area",
   "z_min": 1
  }
 },
 "PE": {
  "pos4": {
   "description": "5-digit postcode area",
   "z_min": 3
  },
  "bounds": [
   -81.3282,
   -18.3517,
   -68.6521,
   -0.0389
  ],
  "feature_id": 11538606,
  "adm1": {
   "description": "province",
   "z_min": 0
  },
  "pos3": {
   "description": "2-digit postcode area",
   "z_min": 2
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm3": {
   "description": "districts",
   "z_min": 2
  },
  "adm2": {
   "description": "province",
   "z_min": 1
  }
 },
 "PL": {
  "pos4": {
   "description": "5-digit postcode area",
   "z_min": 7
  },
  "bounds": [
   14.1229,
   49.002,
   24.1458,
   54.8358
  ],
  "feature_id": 11735219,
  "sta3": {
   "description": "NUTS 3",
   "z_min": 2
  },
  "sta1": {
   "description": "NUTS 1",
   "z_min": 0
  },
  "adm4": {
   "description": "urban municipality",
   "z_min": 5
  },
  "adm1": {
   "description": "voivodeship",
   "z_min": 0
  },
  "pos3": {
   "description": "2-digit postcode area",
   "z_min": 2
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm3": {
   "description": "urban municipality",
   "z_min": 4
  },
  "adm2": {
   "description": "city powiat",
   "z_min": 2
  },
  "sta2": {
   "description": "NUTS 2",
   "z_min": 1
  }
 },
 "PR": {
  "pos4": {
   "description": "5-digit postcode area",
   "z_min": 3
  },
  "bounds": [
   -67.9514,
   17.8814,
   -65.2211,
   18.516
  ],
  "feature_id": 11866294,
  "adm1": {
   "description": "territory",
   "z_min": 2
  },
  "pos3": {
   "description": "3-digit postcode area",
   "z_min": 1
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm3": {
   "description": "submunicipality",
   "z_min": 6
  },
  "adm2": {
   "description": "municipality",
   "z_min": 4
  }
 },
 "PT": {
  "pos4": {
   "description": "7-digit postcode area",
   "z_min": 9
  },
  "bounds": [
   -31.269,
   30.0305,
   -6.1892,
   42.1543
  ],
  "feature_id": 11800760,
  "sta3": {
   "description": "NUTS 3",
   "z_min": 2
  },
  "sta1": {
   "description": "NUTS 1",
   "z_min": 0
  },
  "adm1": {
   "description": "autonomous region",
   "z_min": 1
  },
  "pos2": {
   "description": "2-digit postcode area",
   "z_min": 2
  },
  "pos3": {
   "description": "4-digit postcode area",
   "z_min": 3
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm3": {
   "description": "parish",
   "z_min": 6
  },
  "adm2": {
   "description": "local council",
   "z_min": 3
  },
  "sta2": {
   "description": "NUTS 2",
   "z_min": 1
  }
 },
 "PY": {
  "pos4": {
   "description": "2-4-digit postcode area",
   "z_min": 2
  },
  "bounds": [
   -62.6415,
   -27.5759,
   -54.2608,
   -19.2928
  ],
  "feature_id": 11473082,
  "adm1": {
   "description": "department",
   "z_min": 0
  },
  "pos3": {
   "description": "2-digit postcode area",
   "z_min": 2
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm2": {
   "description": "district",
   "z_min": 1
  }
 },
 "RE": {
  "pos4": {
   "description": "5-digit postcode area",
   "z_min": 2
  },
  "bounds": [
   55.2165,
   -21.3896,
   55.8366,
   -20.8718
  ],
  "feature_id": 11997372,
  "adm4": {
   "description": "commune",
   "z_min": 6
  },
  "adm1": {
   "description": "region",
   "z_min": 0
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm3": {
   "description": "arrondissement",
   "z_min": 2
  },
  "adm2": {
   "description": "department",
   "z_min": 1
  }
 },
 "RO": {
  "pos4": {
   "description": "4-6-digit postcode area",
   "z_min": 6
  },
  "bounds": [
   20.262,
   43.6188,
   29.7153,
   48.2654
  ],
  "feature_id": 12062909,
  "sta3": {
   "description": "NUTS 3",
   "z_min": 2
  },
  "sta1": {
   "description": "NUTS 1",
   "z_min": 0
  },
  "adm1": {
   "description": "county",
   "z_min": 1
  },
  "pos3": {
   "description": "2-digit postcode area",
   "z_min": 2
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm2": {
   "description": "commune",
   "z_min": 4
  },
  "sta2": {
   "description": "NUTS 2",
   "z_min": 1
  }
 },
 "RS": {
  "pos4": {
   "description": "5-digit postcode area",
   "z_min": 6
  },
  "bounds": [
   18.838,
   42.2357,
   23.006,
   46.1898
  ],
  "feature_id": 13045950,
  "sta1": {
   "description": "region",
   "z_min": 0
  },
  "adm1": {
   "description": "district",
   "z_min": 1
  },
  "pos3": {
   "description": "2-digit postcode area",
   "z_min": 2
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm2": {
   "description": "municipality",
   "z_min": 2
  }
 },
 "SE": {
  "pos4": {
   "description": "5-digit postcode area",
   "z_min": 4
  },
  "bounds": [
   10.9577,
   55.3367,
   24.1761,
   69.0599
  ],
  "feature_id": 14291141,
  "sta3": {
   "description": "NUTS 3",
   "z_min": 1
  },
  "sta1": {
   "description": "NUTS 1",
   "z_min": 0
  },
  "adm1": {
   "description": "county",
   "z_min": 0
  },
  "pos3": {
   "description": "2-digit postcode area",
   "z_min": 2
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm2": {
   "description": "municipality",
   "z_min": 2
  },
  "sta2": {
   "description": "NUTS 2",
   "z_min": 1
  }
 },
 "SG": {
  "pos4": {
   "description": "6-digit postcode area",
   "z_min": 8
  },
  "bounds": [
   103.6057,
   1.1587,
   104.0885,
   1.4709
  ],
  "feature_id": 13242566,
  "sta3": {
   "description": "subzone",
   "z_min": 2
  },
  "leg1": {
   "description": "constituency",
   "z_min": 1
  },
  "sta1": {
   "description": "region",
   "z_min": 0
  },
  "adm1": {
   "description": "community development council",
   "z_min": 0
  },
  "pos3": {
   "description": "2-digit postcode area",
   "z_min": 2
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "sta2": {
   "description": "planning area",
   "z_min": 1
  }
 },
 "SI": {
  "pos4": {
   "description": "4-digit postcode area",
   "z_min": 7
  },
  "bounds": [
   13.3757,
   45.4216,
   16.6118,
   46.8768
  ],
  "feature_id": 13439176,
  "sta3": {
   "description": "NUTS 3",
   "z_min": 1
  },
  "sta1": {
   "description": "NUTS 1",
   "z_min": 0
  },
  "adm1": {
   "description": "municipality",
   "z_min": 2
  },
  "pos3": {
   "description": "2-digit postcode area",
   "z_min": 2
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm2": {
   "description": "settlement",
   "z_min": 4
  },
  "sta2": {
   "description": "NUTS 2",
   "z_min": 1
  }
 },
 "SJ": {
  "pos4": {
   "description": "4-digit postcode area",
   "z_min": 4
  },
  "bounds": [
   -9.0864,
   70.8278,
   37.0668,
   80.8212
  ],
  "feature_id": 14160073,
  "sta3": {
   "description": "NUTS 3",
   "z_min": 2
  },
  "sta1": {
   "description": "NUTS 1",
   "z_min": 0
  },
  "adm1": {
   "description": "region",
   "z_min": 0
  },
  "pos3": {
   "description": "2-digit postcode area",
   "z_min": 2
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm2": {
   "description": "island",
   "z_min": 2
  },
  "sta2": {
   "description": "NUTS 2",
   "z_min": 1
  }
 },
 "SK": {
  "pos4": {
   "description": "5-digit postcode area",
   "z_min": 5
  },
  "bounds": [
   16.8332,
   47.7312,
   22.5665,
   49.6138
  ],
  "feature_id": 13373642,
  "sta3": {
   "description": "NUTS 3",
   "z_min": 2
  },
  "sta1": {
   "description": "NUTS 1",
   "z_min": 0
  },
  "adm1": {
   "description": "region",
   "z_min": 0
  },
  "pos3": {
   "description": "2-digit postcode area",
   "z_min": 2
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm3": {
   "description": "municipality",
   "z_min": 6
  },
  "adm2": {
   "description": "district",
   "z_min": 2
  },
  "sta2": {
   "description": "NUTS 2",
   "z_min": 1
  }
 },
 "SM": {
  "pos4": {
   "description": "5-digit postcode area",
   "z_min": 5
  },
  "bounds": [
   12.4036,
   43.8937,
   12.5158,
   43.9921
  ],
  "feature_id": 12783820,
  "adm1": {
   "description": "castello",
   "z_min": 3
  },
  "pos3": {
   "description": "2-digit postcode area",
   "z_min": 2
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  }
 },
 "SZ": {
  "pos4": {
   "description": "4-digit postcode area",
   "z_min": 3
  },
  "bounds": [
   30.7908,
   -27.3175,
   32.1322,
   -25.7188
  ],
  "feature_id": 14225621,
  "adm1": {
   "description": "district",
   "z_min": 0
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm2": {
   "description": "constituency",
   "z_min": 1
  }
 },
 "TC": {
  "pos4": {
   "description": "postcode unit",
   "z_min": 2
  },
  "bounds": [
   -72.4829,
   21.1777,
   -71.0828,
   21.9625
  ],
  "feature_id": 15274198,
  "adm1": {
   "description": "territory",
   "z_min": 1
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm2": {
   "description": "district",
   "z_min": 2
  }
 },
 "TH": {
  "pos4": {
   "description": "5-digit postcode area",
   "z_min": 3
  },
  "bounds": [
   97.3435,
   5.612,
   105.6367,
   20.4648
  ],
  "feature_id": 14684378,
  "adm1": {
   "description": "province",
   "z_min": 1
  },
  "pos3": {
   "description": "2-digit postcode area",
   "z_min": 2
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm3": {
   "description": "tambon",
   "z_min": 2
  },
  "adm2": {
   "description": "district",
   "z_min": 2
  }
 },
 "TR": {
  "pos4": {
   "description": "5-digit postcode area",
   "z_min": 4
  },
  "bounds": [
   25.6652,
   35.8129,
   44.8264,
   42.1046
  ],
  "feature_id": 15143137,
  "sta3": {
   "description": "NUTS 3",
   "z_min": 2
  },
  "sta1": {
   "description": "NUTS 1",
   "z_min": 0
  },
  "adm1": {
   "description": "province",
   "z_min": 0
  },
  "pos3": {
   "description": "2-digit postcode area",
   "z_min": 1
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm3": {
   "description": "district;neighborhood",
   "z_min": 3
  },
  "adm2": {
   "description": "district",
   "z_min": 2
  },
  "sta2": {
   "description": "NUTS 2",
   "z_min": 1
  }
 },
 "TW": {
  "pos4": {
   "description": "3-digit postcode area",
   "z_min": 4
  },
  "bounds": [
   114.3593,
   10.3713,
   122.1091,
   26.3853
  ],
  "feature_id": 14487780,
  "adm4": {
   "description": "village",
   "z_min": 3
  },
  "adm1": {
   "description": "special municipality",
   "z_min": 0
  },
  "pos2": {
   "description": "1-digit postcode area",
   "z_min": 2
  },
  "pos3": {
   "description": "2-digit postcode area",
   "z_min": 3
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm3": {
   "description": "district",
   "z_min": 2
  },
  "adm2": {
   "description": "special municipality",
   "z_min": 0
  }
 },
 "US": {
  "pos4": {
   "description": "5-digit postcode area",
   "z_min": 3
  },
  "bounds": [
   -187.5552,
   18.9107,
   -66.9496,
   71.3885
  ],
  "feature_id": 15864041,
  "loc3": {
   "description": "districts",
   "z_min": 5
  },
  "sta3": {
   "description": "county subdivision",
   "z_min": 4
  },
  "leg4": {
   "description": "state house district",
   "z_min": 3
  },
  "leg2": {
   "description": "congressional district",
   "z_min": 1
  },
  "loc4": {
   "description": "neighborhoods",
   "z_min": 6
  },
  "leg1": {
   "description": "senate",
   "z_min": 0
  },
  "leg3": {
   "description": "state senate district",
   "z_min": 2
  },
  "loc2": {
   "description": "cities and CDPs",
   "z_min": 4
  },
  "sta1": {
   "description": "core statistical area",
   "z_min": 1
  },
  "adm4": {
   "description": "municipality",
   "z_min": 5
  },
  "adm1": {
   "description": "state",
   "z_min": 0
  },
  "sta5": {
   "description": "block group",
   "z_min": 6
  },
  "pos3": {
   "description": "2-digit postcode area",
   "z_min": 0
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm3": {
   "description": "minor civil division",
   "z_min": 3
  },
  "sta4": {
   "description": "tract",
   "z_min": 5
  },
  "adm2": {
   "description": "county",
   "z_min": 2
  },
  "loc1": {
   "description": "metropolitan area",
   "z_min": 1
  },
  "sta2": {
   "description": "remainder area",
   "z_min": 2
  }
 },
 "UY": {
  "pos4": {
   "description": "5-digit postcode area",
   "z_min": 2
  },
  "bounds": [
   -58.4891,
   -34.9735,
   -53.1014,
   -30.0853
  ],
  "feature_id": 15667434,
  "adm1": {
   "description": "department",
   "z_min": 0
  },
  "pos3": {
   "description": "2-digit postcode area",
   "z_min": 1
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  }
 },
 "VA": {
  "pos4": {
   "description": "5-digit postcode area",
   "z_min": 5
  },
  "bounds": [
   12.4457,
   41.9003,
   12.4585,
   41.9076
  ],
  "feature_id": 16060652,
  "pos3": {
   "description": "2-digit postcode area",
   "z_min": 2
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  }
 },
 "VG": {
  "pos4": {
   "description": "4-digit postcode area",
   "z_min": 2
  },
  "bounds": [
   -64.8501,
   18.3064,
   -64.2706,
   18.7497
  ],
  "feature_id": 2167023,
  "sta1": {
   "description": "district",
   "z_min": 1
  },
  "adm1": {
   "description": "territory",
   "z_min": 1
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  }
 },
 "VI": {
  "pos4": {
   "description": "5-digit postcode area",
   "z_min": 2
  },
  "bounds": [
   -65.0853,
   17.674,
   -64.5652,
   18.413
  ],
  "feature_id": 15798512,
  "adm1": {
   "description": "territory",
   "z_min": 0
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm3": {
   "description": "subdistrict",
   "z_min": 1
  },
  "adm2": {
   "description": "district",
   "z_min": 1
  }
 },
 "XS": {
  "pos4": {
   "description": "4-digit postcode area",
   "z_min": 6
  },
  "bounds": [
   32.7549,
   34.5623,
   33.9166,
   35.1237
  ],
  "feature_id": 16716022,
  "adm1": {
   "description": "base area",
   "z_min": 1
  },
  "pos3": {
   "description": "2-digit postcode area",
   "z_min": 3
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm2": {
   "description": "community",
   "z_min": 4
  }
 },
 "YT": {
  "pos4": {
   "description": "5-digit postcode area",
   "z_min": 4
  },
  "bounds": [
   45.0181,
   -13.0058,
   45.3,
   -12.636
  ],
  "feature_id": 9441528,
  "adm4": {
   "description": "commune",
   "z_min": 6
  },
  "adm1": {
   "description": "region",
   "z_min": 0
  },
  "pos3": {
   "description": "2-digit postcode area",
   "z_min": 2
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm3": {
   "description": "arrondissement",
   "z_min": 2
  },
  "adm2": {
   "description": "department",
   "z_min": 1
  }
 },
 "ZA": {
  "pos4": {
   "description": "4-digit postcode area",
   "z_min": 4
  },
  "bounds": [
   16.4519,
   -34.8342,
   32.8911,
   -22.125
  ],
  "feature_id": 13635833,
  "leg5": {
   "description": "ward",
   "z_min": 2
  },
  "adm1": {
   "description": "province",
   "z_min": 0
  },
  "pos3": {
   "description": "2-digit postcode area",
   "z_min": 2
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm3": {
   "description": "local municipality",
   "z_min": 2
  },
  "adm2": {
   "description": "district municipality",
   "z_min": 1
  }
 },
 "CC": {
  "sta3": {
   "description": "statistical areas level 3",
   "z_min": 1
  },
  "bounds": [
   96.8169,
   -12.2087,
   96.9295,
   -11.8146
  ],
  "feature_id": 3412007,
  "sta1": {
   "description": "territory",
   "z_min": 0
  },
  "adm1": {
   "description": "territory",
   "z_min": 0
  },
  "sta5": {
   "description": "statistical areas level 1",
   "z_min": 5
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "sta4": {
   "description": "statistical areas level 2",
   "z_min": 2
  },
  "sta2": {
   "description": "statistical areas level 4",
   "z_min": 0
  }
 },
 "CX": {
  "sta3": {
   "description": "statistical areas level 3",
   "z_min": 1
  },
  "bounds": [
   105.5333,
   -10.5705,
   105.7126,
   -10.4124
  ],
  "feature_id": 3346486,
  "sta1": {
   "description": "territory",
   "z_min": 0
  },
  "adm1": {
   "description": "territory",
   "z_min": 0
  },
  "sta5": {
   "description": "statistical areas level 1",
   "z_min": 5
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "sta4": {
   "description": "statistical areas level 2",
   "z_min": 2
  },
  "sta2": {
   "description": "statistical areas level 4",
   "z_min": 0
  }
 },
 "HM": {
  "sta3": {
   "description": "statistical areas level 3",
   "z_min": 1
  },
  "bounds": [
   72.5827,
   -53.1949,
   73.8764,
   -52.9022
  ],
  "feature_id": 6623328,
  "sta1": {
   "description": "territory",
   "z_min": 0
  },
  "adm1": {
   "description": "territory",
   "z_min": 0
  },
  "sta5": {
   "description": "statistical areas level 1",
   "z_min": 5
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "sta4": {
   "description": "statistical areas level 2",
   "z_min": 2
  },
  "sta2": {
   "description": "statistical areas level 4",
   "z_min": 0
  }
 },
 "IE": {
  "sta3": {
   "description": "NUTS 3",
   "z_min": 1
  },
  "bounds": [
   -10.663,
   51.4199,
   -5.9942,
   55.4351
  ],
  "feature_id": 7147622,
  "leg4": {
   "description": "Local Electoral Areas",
   "z_min": 2
  },
  "sta1": {
   "description": "NUTS 1",
   "z_min": 0
  },
  "adm1": {
   "description": "county",
   "z_min": 3
  },
  "pos2": {
   "description": "2-digit postcode area",
   "z_min": 2
  },
  "sta5": {
   "description": "LAU 2",
   "z_min": 3
  },
  "pos3": {
   "description": "3-digit postcode area",
   "z_min": 3
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "sta4": {
   "description": "LAU 1",
   "z_min": 2
  },
  "adm2": {
   "description": "municipal district",
   "z_min": 4
  },
  "sta2": {
   "description": "NUTS 2",
   "z_min": 1
  }
 },
 "MT": {
  "sta3": {
   "description": "NUTS 3",
   "z_min": 1
  },
  "bounds": [
   14.1834,
   35.8062,
   14.5765,
   36.0824
  ],
  "feature_id": 9113753,
  "sta1": {
   "description": "NUTS 1",
   "z_min": 0
  },
  "adm1": {
   "description": "region",
   "z_min": 1
  },
  "pos2": {
   "description": "3-digit postcode area",
   "z_min": 2
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "sta4": {
   "description": "LAU 1",
   "z_min": 2
  },
  "adm2": {
   "description": "municipality",
   "z_min": 2
  },
  "sta2": {
   "description": "NUTS 2",
   "z_min": 1
  }
 },
 "NF": {
  "sta3": {
   "description": "statistical areas level 3",
   "z_min": 1
  },
  "bounds": [
   167.9138,
   -29.1366,
   167.998,
   -28.9942
  ],
  "feature_id": 10817699,
  "sta1": {
   "description": "territory",
   "z_min": 0
  },
  "adm1": {
   "description": "territory",
   "z_min": 0
  },
  "sta5": {
   "description": "statistical areas level 1",
   "z_min": 5
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "sta4": {
   "description": "statistical areas level 2",
   "z_min": 2
  },
  "sta2": {
   "description": "statistical areas level 4",
   "z_min": 0
  }
 },
 "XK": {
  "sta3": {
   "description": "NUTS 3",
   "z_min": 2
  },
  "bounds": [
   20.0164,
   41.851,
   21.7907,
   43.2681
  ],
  "feature_id": 7934197,
  "sta1": {
   "description": "NUTS 1",
   "z_min": 0
  },
  "adm1": {
   "description": "district",
   "z_min": 0
  },
  "pos3": {
   "description": "2-digit postcode area",
   "z_min": 2
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm2": {
   "description": "municipality",
   "z_min": 1
  },
  "sta2": {
   "description": "NUTS 2",
   "z_min": 1
  }
 },
 "EH": {
  "pos1": {
   "description": "1-digit postcode area",
   "z_min": 1
  },
  "bounds": [
   -17.1033,
   20.7697,
   -8.6663,
   27.6837
  ],
  "feature_id": 16322626,
  "adm1": {
   "description": "region",
   "z_min": 0
  },
  "pos2": {
   "description": "2-digit postcode area",
   "z_min": 2
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm3": {
   "description": "commune",
   "z_min": 1
  },
  "adm2": {
   "description": "province",
   "z_min": 1
  }
 },
 "KE": {
  "pos1": {
   "description": "1-digit postcode area",
   "z_min": 1
  },
  "bounds": [
   33.9216,
   -4.6913,
   41.9109,
   5.0334
  ],
  "feature_id": 7802995,
  "sta1": {
   "description": "province",
   "z_min": 0
  },
  "adm1": {
   "description": "county",
   "z_min": 1
  },
  "pos2": {
   "description": "3-digit postcode area",
   "z_min": 2
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm3": {
   "description": "ward",
   "z_min": 3
  },
  "adm2": {
   "description": "sub-county",
   "z_min": 2
  },
  "sta2": {
   "description": "district",
   "z_min": 1
  }
 },
 "MA": {
  "pos1": {
   "description": "1-digit postcode area",
   "z_min": 0
  },
  "bounds": [
   -13.1671,
   27.6705,
   -1.0108,
   35.9222
  ],
  "feature_id": 9965705,
  "adm1": {
   "description": "region",
   "z_min": 0
  },
  "pos2": {
   "description": "2-digit postcode area",
   "z_min": 2
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm3": {
   "description": "commune",
   "z_min": 3
  },
  "adm2": {
   "description": "province",
   "z_min": 1
  }
 },
 "AI": {
  "pos1": {
   "description": "4-digit postcode area",
   "z_min": 2
  },
  "bounds": [
   -63.4296,
   18.1499,
   -62.9244,
   18.5953
  ],
  "feature_id": 462853,
  "adm1": {
   "description": "territory",
   "z_min": 1
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm2": {
   "description": "district",
   "z_min": 3
  }
 },
 "CL": {
  "pos1": {
   "description": "1-digit postcode area",
   "z_min": 1
  },
  "bounds": [
   -109.4498,
   -55.982,
   -66.4148,
   -17.4986
  ],
  "feature_id": 3018798,
  "adm1": {
   "description": "region",
   "z_min": 0
  },
  "pos2": {
   "description": "3-digit postcode area",
   "z_min": 2
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm3": {
   "description": "municipality",
   "z_min": 2
  },
  "adm2": {
   "description": "province",
   "z_min": 1
  }
 },
 "GG": {
  "pos1": {
   "description": "postcode area",
   "z_min": 2
  },
  "bounds": [
   -2.6751,
   49.4002,
   -2.1586,
   49.7328
  ],
  "feature_id": 6230097,
  "adm1": {
   "description": "crown dependency",
   "z_min": 0
  },
  "pos2": {
   "description": "postcode district",
   "z_min": 4
  },
  "pos3": {
   "description": "postcode sector",
   "z_min": 5
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm2": {
   "description": "parish",
   "z_min": 1
  }
 },
 "HK": {
  "pos1": {
   "description": "2-digit postcode area",
   "z_min": 0
  },
  "bounds": [
   113.8351,
   22.1539,
   114.4417,
   22.562
  ],
  "feature_id": 66064479,
  "adm1": {
   "description": "special administrative region",
   "z_min": 0
  },
  "pos2": {
   "description": "3-digit postcode area",
   "z_min": 1
  },
  "pos3": {
   "description": "4-digit postcode area",
   "z_min": 2
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm3": {
   "description": "district",
   "z_min": 2
  },
  "adm2": {
   "description": "prefecture",
   "z_min": 1
  }
 },
 "IM": {
  "pos1": {
   "description": "postcode area",
   "z_min": 2
  },
  "bounds": [
   -4.8307,
   54.0431,
   -4.3079,
   54.4181
  ],
  "feature_id": 7213160,
  "sta1": {
   "description": "sheading",
   "z_min": 1
  },
  "adm1": {
   "description": "crown dependency",
   "z_min": 0
  },
  "pos2": {
   "description": "postcode district",
   "z_min": 4
  },
  "pos3": {
   "description": "postcode sector",
   "z_min": 5
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm2": {
   "description": "village",
   "z_min": 1
  }
 },
 "IR": {
  "pos1": {
   "description": "2-digit postcode area",
   "z_min": 1
  },
  "bounds": [
   44.0319,
   25.0591,
   63.3209,
   39.7831
  ],
  "feature_id": 7016556,
  "adm1": {
   "description": "province",
   "z_min": 0
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm2": {
   "description": "county",
   "z_min": 1
  }
 },
 "JE": {
  "pos1": {
   "description": "postcode area",
   "z_min": 2
  },
  "bounds": [
   -2.2545,
   49.1631,
   -2.017,
   49.2623
  ],
  "feature_id": 7606383,
  "adm1": {
   "description": "crown dependency",
   "z_min": 0
  },
  "pos2": {
   "description": "postcode district",
   "z_min": 4
  },
  "pos3": {
   "description": "postcode sector",
   "z_min": 5
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm2": {
   "description": "parish",
   "z_min": 1
  }
 },
 "JM": {
  "pos1": {
   "description": "1-digit postcode area",
   "z_min": 2
  },
  "bounds": [
   -78.3688,
   17.7058,
   -76.1829,
   18.525
  ],
  "feature_id": 7475312,
  "adm1": {
   "description": "parish",
   "z_min": 2
  },
  "pos2": {
   "description": "3-digit postcode area",
   "z_min": 3
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  }
 },
 "JO": {
  "pos1": {
   "description": "2-digit postcode area",
   "z_min": 2
  },
  "bounds": [
   34.9581,
   29.1896,
   39.3001,
   33.3746
  ],
  "feature_id": 7671921,
  "adm1": {
   "description": "governorate",
   "z_min": 0
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm2": {
   "description": "district",
   "z_min": 1
  }
 },
 "MO": {
  "pos1": {
   "description": "2-digit postcode area",
   "z_min": 0
  },
  "bounds": [
   113.5287,
   22.1097,
   113.5983,
   22.217
  ],
  "feature_id": 66130068,
  "adm1": {
   "description": "special administrative region",
   "z_min": 0
  },
  "pos2": {
   "description": "3-digit postcode area",
   "z_min": 1
  },
  "pos3": {
   "description": "4-digit postcode area",
   "z_min": 2
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm2": {
   "description": "prefecture",
   "z_min": 1
  }
 },
 "MU": {
  "pos1": {
   "description": "1-digit postcode area",
   "z_min": 0
  },
  "bounds": [
   56.5853,
   -20.5255,
   63.5033,
   -10.3372
  ],
  "feature_id": 9375898,
  "adm1": {
   "description": "district",
   "z_min": 0
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  }
 },
 "SA": {
  "pos1": {
   "description": "1-digit postcode area",
   "z_min": 0
  },
  "bounds": [
   34.4953,
   16.3795,
   55.6666,
   32.1537
  ],
  "feature_id": 12914881,
  "adm1": {
   "description": "region",
   "z_min": 0
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm2": {
   "description": "governorate",
   "z_min": 1
  }
 },
 "AE": {
  "loc4": {
   "description": "neighborhood",
   "z_min": 3
  },
  "bounds": [
   51.498,
   22.6308,
   56.3816,
   26.0689
  ],
  "feature_id": 15536130,
  "loc2": {
   "description": "settlement",
   "z_min": 1
  },
  "adm1": {
   "description": "emirate",
   "z_min": 1
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm2": {
   "description": "region",
   "z_min": 2
  }
 },
 "ZM": {
  "leg1": {
   "description": "constituency",
   "z_min": 1
  },
  "bounds": [
   22,
   -18.0765,
   33.703,
   -8.2415
  ],
  "feature_id": 16453882,
  "adm1": {
   "description": "province",
   "z_min": 0
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm2": {
   "description": "district",
   "z_min": 0
  }
 },
 "NP": {
  "loc2": {
   "description": "village",
   "z_min": 2
  },
  "bounds": [
   80.0561,
   26.348,
   88.2105,
   30.448
  ],
  "feature_id": 10293416,
  "sta1": {
   "description": "region",
   "z_min": 0
  },
  "adm1": {
   "description": "province",
   "z_min": 0
  },
  "pos2": {
   "description": "1-digit postcode area",
   "z_min": 1
  },
  "pos3": {
   "description": "3-digit postcode area",
   "z_min": 2
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm2": {
   "description": "district",
   "z_min": 2
  },
  "sta2": {
   "description": "zone",
   "z_min": 1
  }
 },
 "AW": {
  "sta1": {
   "description": "region",
   "z_min": 1
  },
  "bounds": [
   -70.0637,
   12.4118,
   -69.8657,
   12.6234
  ],
  "feature_id": 790542,
  "adm1": {
   "description": "constituent country",
   "z_min": 1
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  }
 },
 "AZ": {
  "sta1": {
   "description": "economic region",
   "z_min": 1
  },
  "bounds": [
   44.7645,
   38.3929,
   50.6248,
   41.913
  ],
  "feature_id": 987152,
  "adm1": {
   "description": "district",
   "z_min": 2
  },
  "pos3": {
   "description": "2-digit postcode area",
   "z_min": 2
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  }
 },
 "CV": {
  "sta1": {
   "description": "island",
   "z_min": 0
  },
  "bounds": [
   -25.3616,
   14.8021,
   -22.6572,
   17.2053
  ],
  "feature_id": 2756660,
  "adm1": {
   "description": "county",
   "z_min": 1
  },
  "pos3": {
   "description": "2-digit postcode area",
   "z_min": 2
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm2": {
   "description": "parish",
   "z_min": 1
  }
 },
 "DO": {
  "sta1": {
   "description": "macro region",
   "z_min": 2
  },
  "bounds": [
   -72.0075,
   17.4706,
   -68.323,
   19.932
  ],
  "feature_id": 4329533,
  "adm1": {
   "description": "province",
   "z_min": 2
  },
  "pos3": {
   "description": "2-digit postcode area",
   "z_min": 2
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm2": {
   "description": "municipality",
   "z_min": 3
  },
  "sta2": {
   "description": "region",
   "z_min": 3
  }
 },
 "MV": {
  "sta1": {
   "description": "former province",
   "z_min": 0
  },
  "bounds": [
   72.6392,
   -0.7037,
   73.7596,
   7.1064
  ],
  "feature_id": 8982683,
  "adm1": {
   "description": "atoll",
   "z_min": 0
  },
  "pos3": {
   "description": "2-digit postcode area",
   "z_min": 2
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  }
 },
 "QA": {
  "sta1": {
   "description": "zone",
   "z_min": 1
  },
  "bounds": [
   50.7501,
   24.4701,
   51.6622,
   26.1833
  ],
  "feature_id": 11931835,
  "adm1": {
   "description": "municipality",
   "z_min": 0
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  }
 },
 "ST": {
  "sta1": {
   "description": "province",
   "z_min": 0
  },
  "bounds": [
   6.46,
   -0.0138,
   7.4625,
   1.701
  ],
  "feature_id": 12849361,
  "adm1": {
   "description": "district",
   "z_min": 1
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "sta2": {
   "description": "region",
   "z_min": 0
  }
 },
 "TN": {
  "sta1": {
   "description": "regions",
   "z_min": 2
  },
  "bounds": [
   7.5227,
   30.2303,
   11.6112,
   37.5597
  ],
  "feature_id": 15077599,
  "adm1": {
   "description": "governorate",
   "z_min": 0
  },
  "pos3": {
   "description": "2-digit postcode area",
   "z_min": 2
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm2": {
   "description": "delegation",
   "z_min": 2
  }
 },
 "WS": {
  "sta1": {
   "description": "itumalo",
   "z_min": 3
  },
  "bounds": [
   -172.8041,
   -14.0772,
   -171.3977,
   -13.4398
  ],
  "feature_id": 12718324,
  "adm1": {
   "description": "itumalo",
   "z_min": 3
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "sta2": {
   "description": "faipule",
   "z_min": 3
  }
 },
 "BD": {
  "adm4": {
   "description": "union",
   "z_min": 4
  },
  "bounds": [
   88.0072,
   20.5751,
   92.6795,
   26.6381
  ],
  "feature_id": 1183763,
  "adm1": {
   "description": "division",
   "z_min": 1
  },
  "pos3": {
   "description": "2-digit postcode area",
   "z_min": 2
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm3": {
   "description": "subdistrict",
   "z_min": 3
  },
  "adm2": {
   "description": "district",
   "z_min": 2
  }
 },
 "HT": {
  "adm4": {
   "description": "section",
   "z_min": 3
  },
  "bounds": [
   -74.4808,
   18.0219,
   -71.6218,
   20.0893
  ],
  "feature_id": 6557795,
  "adm1": {
   "description": "department",
   "z_min": 3
  },
  "pos3": {
   "description": "2-digit postcode area",
   "z_min": 3
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm3": {
   "description": "township",
   "z_min": 3
  },
  "adm2": {
   "description": "arrondissement",
   "z_min": 3
  }
 },
 "BT": {
  "adm1": {
   "description": "district",
   "z_min": 0
  },
  "bounds": [
   88.7683,
   26.6948,
   92.124,
   28.2458
  ],
  "feature_id": 1642529,
  "pos3": {
   "description": "2-digit postcode area",
   "z_min": 2
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm2": {
   "description": "municipality",
   "z_min": 2
  }
 },
 "PK": {
  "adm1": {
   "description": "federal territory",
   "z_min": 0
  },
  "bounds": [
   60.8738,
   23.7046,
   77.1204,
   37.0919
  ],
  "feature_id": 11145394,
  "pos3": {
   "description": "2-digit postcode area",
   "z_min": 2
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm3": {
   "description": "district",
   "z_min": 2
  },
  "adm2": {
   "description": "division",
   "z_min": 1
  }
 },
 "SS": {
  "adm1": {
   "description": "state",
   "z_min": 0
  },
  "bounds": [
   24.1507,
   3.4803,
   35.9353,
   12.2322
  ],
  "feature_id": 13832400,
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm2": {
   "description": "county",
   "z_min": 0
  }
 },
 "VN": {
  "adm1": {
   "description": "province",
   "z_min": 1
  },
  "bounds": [
   102.1448,
   7.6024,
   116.6811,
   23.3923
  ],
  "feature_id": 16191729,
  "pos2": {
   "description": "2-digit postcode area",
   "z_min": 2
  },
  "pos3": {
   "description": "4-digit postcode area",
   "z_min": 4
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm3": {
   "description": "remainder",
   "z_min": 4
  },
  "adm2": {
   "description": "district",
   "z_min": 3
  }
 },
 "AF": {
  "adm1": {
   "description": "province",
   "z_min": 0
  },
  "bounds": [
   60.4734,
   29.3778,
   74.8857,
   38.4911
  ],
  "feature_id": 69635,
  "pos3": {
   "description": "2-digit postcode area",
   "z_min": 0
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm2": {
   "description": "district",
   "z_min": 2
  }
 },
 "AG": {
  "adm1": {
   "description": "parish",
   "z_min": 5
  },
  "bounds": [
   -62.3482,
   16.9323,
   -61.657,
   17.7294
  ],
  "feature_id": 593924,
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  }
 },
 "AM": {
  "adm1": {
   "description": "province",
   "z_min": 2
  },
  "bounds": [
   43.4483,
   38.8402,
   46.633,
   41.2999
  ],
  "feature_id": 724999,
  "pos3": {
   "description": "2-digit postcode area",
   "z_min": 2
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  }
 },
 "AO": {
  "adm1": {
   "description": "province",
   "z_min": 0
  },
  "bounds": [
   11.6693,
   -18.0395,
   24.0837,
   -4.3607
  ],
  "feature_id": 397320,
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm2": {
   "description": "municipality",
   "z_min": 1
  }
 },
 "BB": {
  "adm1": {
   "description": "parish",
   "z_min": 5
  },
  "bounds": [
   -59.6526,
   13.0447,
   -59.4203,
   13.3348
  ],
  "feature_id": 1249298,
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  }
 },
 "BF": {
  "adm1": {
   "description": "region",
   "z_min": 1
  },
  "bounds": [
   -5.5119,
   9.4088,
   2.4048,
   15.0855
  ],
  "feature_id": 2363413,
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm2": {
   "description": "province",
   "z_min": 2
  }
 },
 "BI": {
  "adm1": {
   "description": "province",
   "z_min": 1
  },
  "bounds": [
   29.0007,
   -4.47,
   30.8502,
   -2.31
  ],
  "feature_id": 2428952,
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm2": {
   "description": "district",
   "z_min": 4
  }
 },
 "BJ": {
  "adm1": {
   "description": "department",
   "z_min": 0
  },
  "bounds": [
   0.7798,
   6.2347,
   3.8534,
   12.4092
  ],
  "feature_id": 1511449,
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm2": {
   "description": "municipality",
   "z_min": 1
  }
 },
 "BN": {
  "adm1": {
   "description": "district",
   "z_min": 0
  },
  "bounds": [
   114.0758,
   4.0023,
   115.3634,
   5.0459
  ],
  "feature_id": 2232348,
  "pos2": {
   "description": "2-digit postcode area",
   "z_min": 2
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm2": {
   "description": "subdivision",
   "z_min": 1
  }
 },
 "BO": {
  "adm1": {
   "description": "department",
   "z_min": 0
  },
  "bounds": [
   -69.6444,
   -22.9004,
   -57.4533,
   -9.6648
  ],
  "feature_id": 1708061,
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm3": {
   "description": "municipality",
   "z_min": 2
  },
  "adm2": {
   "description": "province",
   "z_min": 1
  }
 },
 "BQ": {
  "adm1": {
   "description": "island",
   "z_min": 1
  },
  "bounds": [
   -68.4207,
   12.0247,
   -62.9459,
   17.6501
  ],
  "feature_id": 1773598,
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  }
 },
 "BS": {
  "adm1": {
   "description": "district",
   "z_min": 0
  },
  "bounds": [
   -79.3055,
   20.912,
   -72.7118,
   27.2629
  ],
  "feature_id": 1052704,
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  }
 },
 "BV": {
  "adm1": {
   "description": "territory",
   "z_min": 3
  },
  "bounds": [
   3.2845,
   -54.4549,
   3.4333,
   -54.3864
  ],
  "feature_id": 1970210,
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  }
 },
 "BW": {
  "adm1": {
   "description": "district",
   "z_min": 0
  },
  "bounds": [
   19.9974,
   -26.9074,
   29.3714,
   -17.7782
  ],
  "feature_id": 1904675,
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm2": {
   "description": "subdistrict",
   "z_min": 1
  }
 },
 "BZ": {
  "adm1": {
   "description": "district",
   "z_min": 0
  },
  "bounds": [
   -89.225,
   15.8859,
   -87.486,
   18.4958
  ],
  "feature_id": 1445925,
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  }
 },
 "CD": {
  "adm1": {
   "description": "province",
   "z_min": 0
  },
  "bounds": [
   12.2003,
   -13.4548,
   31.3064,
   5.3922
  ],
  "feature_id": 4067368,
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm2": {
   "description": "territory",
   "z_min": 1
  }
 },
 "CF": {
  "adm1": {
   "description": "prefecture",
   "z_min": 0
  },
  "bounds": [
   14.4152,
   2.2227,
   27.4616,
   11.017
  ],
  "feature_id": 2887721,
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm2": {
   "description": "sub-prefecture",
   "z_min": 1
  }
 },
 "CG": {
  "adm1": {
   "description": "department",
   "z_min": 0
  },
  "bounds": [
   11.1466,
   -5.0375,
   18.644,
   3.7122
  ],
  "feature_id": 3608618,
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  }
 },
 "CI": {
  "adm1": {
   "description": "district",
   "z_min": 0
  },
  "bounds": [
   -8.6029,
   4.3609,
   -2.4947,
   10.7397
  ],
  "feature_id": 7409708,
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm3": {
   "description": "department",
   "z_min": 2
  },
  "adm2": {
   "description": "autonomous district",
   "z_min": 1
  }
 },
 "CK": {
  "adm1": {
   "description": "country",
   "z_min": 3
  },
  "bounds": [
   -165.8794,
   -21.9591,
   -157.3206,
   -8.9147
  ],
  "feature_id": 3674157,
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  }
 },
 "CM": {
  "adm1": {
   "description": "region",
   "z_min": 0
  },
  "bounds": [
   8.4987,
   1.6514,
   16.1912,
   13.0809
  ],
  "feature_id": 2560047,
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm2": {
   "description": "department",
   "z_min": 1
  }
 },
 "CU": {
  "adm1": {
   "description": "province",
   "z_min": 1
  },
  "bounds": [
   -84.9521,
   19.8262,
   -74.1314,
   23.2767
  ],
  "feature_id": 3870771,
  "pos3": {
   "description": "3-digit postcode area",
   "z_min": 3
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm2": {
   "description": "municipality",
   "z_min": 3
  }
 },
 "CW": {
  "adm1": {
   "description": "island",
   "z_min": 1
  },
  "bounds": [
   -69.1623,
   11.978,
   -68.6395,
   12.3924
  ],
  "feature_id": 3936309,
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  }
 },
 "DJ": {
  "adm1": {
   "description": "region",
   "z_min": 0
  },
  "bounds": [
   41.7719,
   10.9157,
   43.4537,
   12.7067
  ],
  "feature_id": 4198458,
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm2": {
   "description": "district",
   "z_min": 2
  }
 },
 "DM": {
  "adm1": {
   "description": "parish",
   "z_min": 4
  },
  "bounds": [
   -61.4801,
   15.2076,
   -61.2401,
   15.6402
  ],
  "feature_id": 4263996,
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  }
 },
 "DZ": {
  "adm1": {
   "description": "province",
   "z_min": 0
  },
  "bounds": [
   -8.668,
   18.9562,
   11.9942,
   37.0897
  ],
  "feature_id": 200766,
  "pos3": {
   "description": "2-digit postcode area",
   "z_min": 1
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm2": {
   "description": "commune",
   "z_min": 2
  }
 },
 "EC": {
  "adm1": {
   "description": "Zonas No Delimitadas",
   "z_min": 0
  },
  "bounds": [
   -92.0081,
   -5.0161,
   -75.1944,
   1.6817
  ],
  "feature_id": 4395071,
  "pos2": {
   "description": "2-digit postcode area",
   "z_min": 1
  },
  "pos3": {
   "description": "4-digit postcode area",
   "z_min": 2
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm2": {
   "description": "canton",
   "z_min": 2
  }
 },
 "EG": {
  "adm1": {
   "description": "governorate",
   "z_min": 0
  },
  "bounds": [
   24.6929,
   21.9993,
   36.8944,
   31.6717
  ],
  "feature_id": 4460609,
  "pos3": {
   "description": "2-digit postcode area",
   "z_min": 2
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm2": {
   "description": "region",
   "z_min": 2
  }
 },
 "ER": {
  "adm1": {
   "description": "region",
   "z_min": 0
  },
  "bounds": [
   36.4282,
   12.3629,
   43.1588,
   17.9992
  ],
  "feature_id": 4657219,
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm2": {
   "description": "subregion",
   "z_min": 1
  }
 },
 "ET": {
  "adm1": {
   "description": "city",
   "z_min": 0
  },
  "bounds": [
   32.9997,
   3.3961,
   47.9878,
   14.8942
  ],
  "feature_id": 4788293,
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm3": {
   "description": "district",
   "z_min": 2
  },
  "adm2": {
   "description": "zone",
   "z_min": 1
  }
 },
 "FJ": {
  "adm1": {
   "description": "division",
   "z_min": 3
  },
  "bounds": [
   176.8997,
   -21.0425,
   181.7714,
   -12.4617
  ],
  "feature_id": 4984903,
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm2": {
   "description": "province",
   "z_min": 3
  }
 },
 "FM": {
  "adm1": {
   "description": "state",
   "z_min": 3
  },
  "bounds": [
   137.4253,
   1.0253,
   163.0356,
   10.0906
  ],
  "feature_id": 9572425,
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  }
 },
 "GA": {
  "adm1": {
   "description": "province",
   "z_min": 0
  },
  "bounds": [
   8.6989,
   -3.956,
   14.5281,
   2.318
  ],
  "feature_id": 5378124,
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm2": {
   "description": "department",
   "z_min": 1
  }
 },
 "GD": {
  "adm1": {
   "description": "parish",
   "z_min": 5
  },
  "bounds": [
   -61.8024,
   11.9849,
   -61.3783,
   12.5402
  ],
  "feature_id": 5967950,
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  }
 },
 "GE": {
  "adm1": {
   "description": "region",
   "z_min": 0
  },
  "bounds": [
   40.0068,
   41.0553,
   46.7365,
   43.5863
  ],
  "feature_id": 5509199,
  "pos3": {
   "description": "2-digit postcode area",
   "z_min": 2
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm2": {
   "description": "city",
   "z_min": 2
  }
 },
 "GH": {
  "adm1": {
   "description": "region",
   "z_min": 0
  },
  "bounds": [
   -3.2551,
   4.7392,
   1.2001,
   11.1683
  ],
  "feature_id": 5640274,
  "pos3": {
   "description": "2-digit postcode",
   "z_min": 0
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm2": {
   "description": "district",
   "z_min": 1
  }
 },
 "GM": {
  "adm1": {
   "description": "region",
   "z_min": 0
  },
  "bounds": [
   -16.8137,
   13.0432,
   -13.7917,
   13.8266
  ],
  "feature_id": 5443669,
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm2": {
   "description": "district",
   "z_min": 1
  }
 },
 "GN": {
  "adm1": {
   "description": "region",
   "z_min": 0
  },
  "bounds": [
   -15.0761,
   7.1905,
   -7.6374,
   12.6756
  ],
  "feature_id": 6295638,
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm3": {
   "description": "municipality",
   "z_min": 2
  },
  "adm2": {
   "description": "prefecture",
   "z_min": 1
  }
 },
 "GQ": {
  "adm1": {
   "description": "region",
   "z_min": 0
  },
  "bounds": [
   5.6169,
   -1.4681,
   11.3654,
   3.7883
  ],
  "feature_id": 4591704,
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm2": {
   "description": "province",
   "z_min": 1
  }
 },
 "GT": {
  "adm1": {
   "description": "department",
   "z_min": 0
  },
  "bounds": [
   -92.2296,
   13.7402,
   -88.2333,
   17.8166
  ],
  "feature_id": 6164571,
  "pos3": {
   "description": "2-digit postcode area",
   "z_min": 2
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm2": {
   "description": "municipality",
   "z_min": 3
  }
 },
 "GW": {
  "adm1": {
   "description": "region",
   "z_min": 0
  },
  "bounds": [
   -16.7153,
   10.8643,
   -13.6342,
   12.6855
  ],
  "feature_id": 6361181,
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm2": {
   "description": "sector",
   "z_min": 1
  }
 },
 "GY": {
  "adm1": {
   "description": "region",
   "z_min": 0
  },
  "bounds": [
   -61.3918,
   1.1693,
   -56.4851,
   8.5349
  ],
  "feature_id": 6426718,
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm2": {
   "description": "neighbourhood democratic council",
   "z_min": 1
  }
 },
 "HN": {
  "adm1": {
   "description": "department",
   "z_min": 0
  },
  "bounds": [
   -89.3564,
   12.9831,
   -83.1488,
   16.5168
  ],
  "feature_id": 6688865,
  "pos2": {
   "description": "2-digit postcode areas",
   "z_min": 1
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm3": {
   "description": "settlement",
   "z_min": 3
  },
  "adm2": {
   "description": "municipality",
   "z_min": 3
  }
 },
 "IL": {
  "adm1": {
   "description": "district",
   "z_min": 0
  },
  "bounds": [
   34.2678,
   29.4956,
   35.8962,
   33.333
  ],
  "feature_id": 7278695,
  "pos2": {
   "description": "2-digit postcode area",
   "z_min": 2
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm3": {
   "description": "natural region",
   "z_min": 2
  },
  "adm2": {
   "description": "subdistrict",
   "z_min": 1
  }
 },
 "IO": {
  "adm1": {
   "description": "territory",
   "z_min": 3
  },
  "bounds": [
   71.2374,
   -7.4446,
   72.4957,
   -5.236
  ],
  "feature_id": 2101354,
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  }
 },
 "IQ": {
  "adm1": {
   "description": "governorate",
   "z_min": 0
  },
  "bounds": [
   38.7923,
   29.0583,
   48.6128,
   37.3815
  ],
  "feature_id": 7082091,
  "pos3": {
   "description": "2-digit postcode area",
   "z_min": 2
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm2": {
   "description": "district",
   "z_min": 1
  }
 },
 "KG": {
  "adm1": {
   "description": "province",
   "z_min": 0
  },
  "bounds": [
   69.2639,
   39.1824,
   80.2504,
   43.2655
  ],
  "feature_id": 8065140,
  "pos2": {
   "description": "3-digit postcode area",
   "z_min": 1
  },
  "pos3": {
   "description": "4-digit postcode area",
   "z_min": 2
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm2": {
   "description": "district",
   "z_min": 1
  }
 },
 "KH": {
  "adm1": {
   "description": "province",
   "z_min": 0
  },
  "bounds": [
   102.3337,
   10.3531,
   107.6316,
   14.69
  ],
  "feature_id": 2494581,
  "pos3": {
   "description": "3-digit postcode area",
   "z_min": 2
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm3": {
   "description": "commune",
   "z_min": 1
  },
  "adm2": {
   "description": "district",
   "z_min": 1
  }
 },
 "KM": {
  "adm1": {
   "description": "province",
   "z_min": 0
  },
  "bounds": [
   43.2291,
   -12.4221,
   44.5405,
   -11.3649
  ],
  "feature_id": 3543159,
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  }
 },
 "KN": {
  "adm1": {
   "description": "island",
   "z_min": 0
  },
  "bounds": [
   -62.8643,
   17.0941,
   -62.5395,
   17.4178
  ],
  "feature_id": 12390520,
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm2": {
   "description": "parish",
   "z_min": 5
  }
 },
 "KP": {
  "adm1": {
   "description": "province",
   "z_min": 0
  },
  "bounds": [
   124.1813,
   37.6769,
   130.6998,
   43.009
  ],
  "feature_id": 10883193,
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm2": {
   "description": "county",
   "z_min": 2
  }
 },
 "KY": {
  "adm1": {
   "description": "territory",
   "z_min": 1
  },
  "bounds": [
   -81.4202,
   19.263,
   -79.723,
   19.7569
  ],
  "feature_id": 2822268,
  "pos2": {
   "description": "1-digit postcode area",
   "z_min": 2
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm2": {
   "description": "district",
   "z_min": 2
  }
 },
 "KZ": {
  "adm1": {
   "description": "city",
   "z_min": 0
  },
  "bounds": [
   46.4929,
   40.5688,
   87.3147,
   55.4454
  ],
  "feature_id": 7737469,
  "pos2": {
   "description": "2-digit postcode area",
   "z_min": 0
  },
  "pos3": {
   "description": "4-digit postcode area",
   "z_min": 2
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm2": {
   "description": "district",
   "z_min": 1
  }
 },
 "LA": {
  "adm1": {
   "description": "province",
   "z_min": 0
  },
  "bounds": [
   100.0818,
   13.9098,
   107.635,
   22.5049
  ],
  "feature_id": 8130686,
  "pos3": {
   "description": "2-digit postcode area",
   "z_min": 2
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm2": {
   "description": "district",
   "z_min": 2
  }
 },
 "LB": {
  "adm1": {
   "description": "governorate",
   "z_min": 1
  },
  "bounds": [
   35.1036,
   33.0554,
   36.6233,
   34.6921
  ],
  "feature_id": 8261759,
  "pos3": {
   "description": "2-digit postcode area",
   "z_min": 2
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm2": {
   "description": "district",
   "z_min": 3
  }
 },
 "LC": {
  "adm1": {
   "description": "district",
   "z_min": 5
  },
  "bounds": [
   -61.0798,
   13.7076,
   -60.8732,
   14.1104
  ],
  "feature_id": 12456064,
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  }
 },
 "LK": {
  "adm1": {
   "description": "province",
   "z_min": 0
  },
  "bounds": [
   79.6505,
   5.9216,
   81.8789,
   9.8358
  ],
  "feature_id": 13963394,
  "pos2": {
   "description": "2-digit postcode area",
   "z_min": 2
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm2": {
   "description": "district",
   "z_min": 1
  }
 },
 "LR": {
  "adm1": {
   "description": "county",
   "z_min": 1
  },
  "bounds": [
   -11.4917,
   4.3535,
   -7.3672,
   8.551
  ],
  "feature_id": 8392835,
  "pos3": {
   "description": "2-digit postcode area",
   "z_min": 2
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm2": {
   "description": "district",
   "z_min": 2
  }
 },
 "LS": {
  "adm1": {
   "description": "district",
   "z_min": 0
  },
  "bounds": [
   27.0112,
   -30.6756,
   29.4557,
   -28.5708
  ],
  "feature_id": 8327300,
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  }
 },
 "LY": {
  "adm1": {
   "description": "district",
   "z_min": 0
  },
  "bounds": [
   9.3923,
   19.5087,
   25.1471,
   33.1669
  ],
  "feature_id": 8458376,
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  }
 },
 "MG": {
  "adm1": {
   "description": "region",
   "z_min": 0
  },
  "bounds": [
   43.1885,
   -25.6062,
   50.4861,
   -11.9487
  ],
  "feature_id": 8786062,
  "pos2": {
   "description": "1-digit postcode area",
   "z_min": 1
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm2": {
   "description": "district",
   "z_min": 2
  }
 },
 "MH": {
  "adm1": {
   "description": "municipality",
   "z_min": 3
  },
  "bounds": [
   160.7953,
   4.5725,
   172.1725,
   14.7232
  ],
  "feature_id": 9179279,
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  }
 },
 "ML": {
  "adm1": {
   "description": "region",
   "z_min": 0
  },
  "bounds": [
   -12.2403,
   10.1521,
   4.2493,
   24.9999
  ],
  "feature_id": 9048209,
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm2": {
   "description": "district",
   "z_min": 1
  }
 },
 "MM": {
  "adm1": {
   "description": "union territory",
   "z_min": 0
  },
  "bounds": [
   92.1721,
   9.5979,
   101.1703,
   28.5484
  ],
  "feature_id": 10096786,
  "pos3": {
   "description": "2-digit postcode area",
   "z_min": 2
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm3": {
   "description": "township",
   "z_min": 2
  },
  "adm2": {
   "description": "district",
   "z_min": 1
  }
 },
 "MN": {
  "adm1": {
   "description": "province",
   "z_min": 0
  },
  "bounds": [
   87.7367,
   41.5827,
   119.9321,
   52.1514
  ],
  "feature_id": 9769107,
  "pos2": {
   "description": "2-digit postcode area",
   "z_min": 0
  },
  "pos3": {
   "description": "4-digit postcode area",
   "z_min": 2
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm2": {
   "description": "district",
   "z_min": 1
  }
 },
 "MR": {
  "adm1": {
   "description": "region",
   "z_min": 0
  },
  "bounds": [
   -17.0698,
   14.7202,
   -4.83,
   27.3129
  ],
  "feature_id": 9310359,
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm2": {
   "description": "department",
   "z_min": 1
  }
 },
 "MW": {
  "adm1": {
   "description": "region",
   "z_min": 0
  },
  "bounds": [
   32.6748,
   -17.1259,
   35.9173,
   -9.3622
  ],
  "feature_id": 8851612,
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm2": {
   "description": "district",
   "z_min": 1
  }
 },
 "MZ": {
  "adm1": {
   "description": "province",
   "z_min": 0
  },
  "bounds": [
   30.2167,
   -26.8681,
   40.8393,
   -10.4709
  ],
  "feature_id": 10031263,
  "pos3": {
   "description": "2-digit postcode area",
   "z_min": 2
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm2": {
   "description": "district",
   "z_min": 1
  }
 },
 "NA": {
  "adm1": {
   "description": "region",
   "z_min": 0
  },
  "bounds": [
   11.7366,
   -28.9695,
   25.2562,
   -16.9635
  ],
  "feature_id": 10162336,
  "pos2": {
   "description": "3-digit postcode area",
   "z_min": 0
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  }
 },
 "NC": {
  "adm1": {
   "description": "collectivity",
   "z_min": 3
  },
  "bounds": [
   158.2487,
   -22.848,
   172.09,
   -18.0264
  ],
  "feature_id": 10424481,
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  }
 },
 "NE": {
  "adm1": {
   "description": "region",
   "z_min": 0
  },
  "bounds": [
   0.1673,
   11.6954,
   15.9979,
   23.518
  ],
  "feature_id": 10621090,
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm2": {
   "description": "department",
   "z_min": 1
  }
 },
 "NG": {
  "adm1": {
   "description": "state",
   "z_min": 0
  },
  "bounds": [
   2.6732,
   4.2707,
   14.678,
   13.8934
  ],
  "feature_id": 10686628,
  "pos2": {
   "description": "2-digit postcode area",
   "z_min": 2
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm2": {
   "description": "local government area",
   "z_min": 2
  }
 },
 "NR": {
  "adm1": {
   "description": "district",
   "z_min": 3
  },
  "bounds": [
   166.9095,
   -0.5543,
   166.9593,
   -0.5021
  ],
  "feature_id": 10227881,
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  }
 },
 "NU": {
  "adm1": {
   "description": "country",
   "z_min": 3
  },
  "bounds": [
   -169.9508,
   -19.1561,
   -169.7737,
   -18.9523
  ],
  "feature_id": 10752170,
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  }
 },
 "OM": {
  "adm1": {
   "description": "governorate",
   "z_min": 0
  },
  "bounds": [
   52,
   16.6501,
   59.8398,
   26.4049
  ],
  "feature_id": 11079852,
  "pos2": {
   "description": "1-digit postcode area",
   "z_min": 2
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm2": {
   "description": "district",
   "z_min": 1
  }
 },
 "PA": {
  "adm1": {
   "description": "province",
   "z_min": 0
  },
  "bounds": [
   -83.0516,
   7.2038,
   -77.1394,
   9.6457
  ],
  "feature_id": 11341997,
  "pos3": {
   "description": "2-digit postcode areas",
   "z_min": 1
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm2": {
   "description": "district",
   "z_min": 2
  }
 },
 "PF": {
  "adm1": {
   "description": "collectivity",
   "z_min": 0
  },
  "bounds": [
   -154.7272,
   -27.9005,
   -134.4511,
   -7.895
  ],
  "feature_id": 5247151,
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  }
 },
 "PG": {
  "adm1": {
   "description": "province",
   "z_min": 0
  },
  "bounds": [
   140.8424,
   -11.6554,
   155.9831,
   -1.3148
  ],
  "feature_id": 11407536,
  "pos3": {
   "description": "2-digit postcode area",
   "z_min": 2
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm2": {
   "description": "district",
   "z_min": 1
  }
 },
 "PM": {
  "adm1": {
   "description": "collectivity",
   "z_min": 3
  },
  "bounds": [
   -56.406,
   46.7489,
   -56.1266,
   47.145
  ],
  "feature_id": 12587188,
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  }
 },
 "PN": {
  "adm1": {
   "description": "territory",
   "z_min": 3
  },
  "bounds": [
   -130.7562,
   -25.0798,
   -124.772,
   -23.9077
  ],
  "feature_id": 11669685,
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  }
 },
 "PS": {
  "adm1": {
   "description": "district",
   "z_min": 0
  },
  "bounds": [
   34.2186,
   31.2199,
   35.5739,
   32.5525
  ],
  "feature_id": 11276471,
  "pos2": {
   "description": "2-digit postcode area",
   "z_min": 2
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm2": {
   "description": "governorate",
   "z_min": 2
  }
 },
 "PW": {
  "adm1": {
   "description": "state",
   "z_min": 3
  },
  "bounds": [
   131.1199,
   2.9714,
   134.7214,
   8.0942
  ],
  "feature_id": 11210937,
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  }
 },
 "RW": {
  "adm1": {
   "description": "province",
   "z_min": 0
  },
  "bounds": [
   28.862,
   -2.8388,
   30.8991,
   -1.0479
  ],
  "feature_id": 12193984,
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm3": {
   "description": "sector",
   "z_min": 2
  },
  "adm2": {
   "description": "district",
   "z_min": 1
  }
 },
 "SB": {
  "adm1": {
   "description": "province",
   "z_min": 3
  },
  "bounds": [
   155.5122,
   -12.3083,
   170.1925,
   -5.0269
  ],
  "feature_id": 13504706,
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  }
 },
 "SC": {
  "adm1": {
   "description": "district",
   "z_min": 0
  },
  "bounds": [
   46.2029,
   -10.2271,
   56.2947,
   -3.7129
  ],
  "feature_id": 13111491,
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  }
 },
 "SD": {
  "adm1": {
   "description": "state",
   "z_min": 0
  },
  "bounds": [
   21.8143,
   8.683,
   38.8492,
   22.0065
  ],
  "feature_id": 14028996,
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm2": {
   "description": "district",
   "z_min": 1
  }
 },
 "SH": {
  "adm1": {
   "description": "territory",
   "z_min": 3
  },
  "bounds": [
   -14.421,
   -40.3714,
   -5.6341,
   -7.8892
  ],
  "feature_id": 12325063,
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  }
 },
 "SL": {
  "adm1": {
   "description": "province",
   "z_min": 0
  },
  "bounds": [
   -13.3064,
   6.9246,
   -10.2741,
   10.0001
  ],
  "feature_id": 13177035,
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm2": {
   "description": "district",
   "z_min": 1
  }
 },
 "SN": {
  "adm1": {
   "description": "region",
   "z_min": 0
  },
  "bounds": [
   -17.5302,
   12.3068,
   -11.3463,
   16.6916
  ],
  "feature_id": 12980429,
  "pos3": {
   "description": "2-digit postcode areas",
   "z_min": 0
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm2": {
   "description": "department",
   "z_min": 1
  }
 },
 "SO": {
  "adm1": {
   "description": "region",
   "z_min": 0
  },
  "bounds": [
   40.9924,
   -1.6627,
   51.4156,
   11.9893
  ],
  "feature_id": 13570254,
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm2": {
   "description": "district",
   "z_min": 1
  }
 },
 "SR": {
  "adm1": {
   "description": "district",
   "z_min": 0
  },
  "bounds": [
   -58.0547,
   1.8344,
   -53.9798,
   6.0088
  ],
  "feature_id": 14094543,
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm2": {
   "description": "resort",
   "z_min": 1
  }
 },
 "SV": {
  "adm1": {
   "description": "department",
   "z_min": 0
  },
  "bounds": [
   -90.1327,
   13.1524,
   -87.6905,
   14.451
  ],
  "feature_id": 4526290,
  "pos2": {
   "description": "1-digit postcode areas",
   "z_min": 0
  },
  "pos3": {
   "description": "2-digit postcode areas",
   "z_min": 0
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm2": {
   "description": "municipality",
   "z_min": 3
  }
 },
 "SX": {
  "adm1": {
   "description": "island",
   "z_min": 1
  },
  "bounds": [
   -63.1373,
   18.0051,
   -63.0135,
   18.0626
  ],
  "feature_id": 13308115,
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  }
 },
 "SY": {
  "adm1": {
   "description": "governorate",
   "z_min": 0
  },
  "bounds": [
   35.7167,
   32.3116,
   42.3764,
   37.3188
  ],
  "feature_id": 14422228,
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm2": {
   "description": "district",
   "z_min": 1
  }
 },
 "TD": {
  "adm1": {
   "description": "governorate",
   "z_min": 0
  },
  "bounds": [
   13.4731,
   7.4418,
   24.0016,
   23.4504
  ],
  "feature_id": 2953431,
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm2": {
   "description": "prefecture",
   "z_min": 1
  }
 },
 "TF": {
  "adm1": {
   "description": "territory",
   "z_min": 3
  },
  "bounds": [
   40.3259,
   -50.0213,
   77.5957,
   -11.5678
  ],
  "feature_id": 5312728,
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  }
 },
 "TG": {
  "adm1": {
   "description": "region",
   "z_min": 0
  },
  "bounds": [
   -0.1438,
   6.1126,
   1.8091,
   11.1373
  ],
  "feature_id": 14815449,
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm2": {
   "description": "prefecture",
   "z_min": 1
  }
 },
 "TJ": {
  "adm1": {
   "description": "capital territory",
   "z_min": 0
  },
  "bounds": [
   67.3422,
   36.6718,
   75.1558,
   41.0442
  ],
  "feature_id": 14553307,
  "pos2": {
   "description": "3-digit postcode area",
   "z_min": 1
  },
  "pos3": {
   "description": "4-digit postcode area",
   "z_min": 2
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm2": {
   "description": "district",
   "z_min": 1
  }
 },
 "TK": {
  "adm1": {
   "description": "territory",
   "z_min": 3
  },
  "bounds": [
   -172.5208,
   -9.444,
   -171.1814,
   -8.532
  ],
  "feature_id": 14880988,
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  }
 },
 "TL": {
  "adm1": {
   "description": "district",
   "z_min": 0
  },
  "bounds": [
   124.043,
   -9.5036,
   127.3423,
   -8.1269
  ],
  "feature_id": 14749917,
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm2": {
   "description": "subdistrict",
   "z_min": 1
  }
 },
 "TM": {
  "adm1": {
   "description": "province",
   "z_min": 0
  },
  "bounds": [
   52.4511,
   35.1308,
   66.6922,
   42.799
  ],
  "feature_id": 15208670,
  "pos3": {
   "description": "3-digit postcode area",
   "z_min": 1
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm2": {
   "description": "district",
   "z_min": 1
  }
 },
 "TO": {
  "adm1": {
   "description": "province",
   "z_min": 3
  },
  "bounds": [
   -176.2137,
   -22.3497,
   -173.7351,
   -15.5659
  ],
  "feature_id": 14946528,
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  }
 },
 "TT": {
  "adm1": {
   "description": "region",
   "z_min": 1
  },
  "bounds": [
   -61.9309,
   10.0425,
   -60.4925,
   11.3588
  ],
  "feature_id": 15012066,
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm2": {
   "description": "parish",
   "z_min": 1
  }
 },
 "TV": {
  "adm1": {
   "description": "province",
   "z_min": 3
  },
  "bounds": [
   176.0588,
   -8.6457,
   179.2034,
   -5.6425
  ],
  "feature_id": 15339747,
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  }
 },
 "TZ": {
  "adm1": {
   "description": "region",
   "z_min": 0
  },
  "bounds": [
   29.3908,
   -11.7613,
   40.4451,
   -0.9858
  ],
  "feature_id": 14618853,
  "pos2": {
   "description": "2-digit postcode area",
   "z_min": 0
  },
  "pos3": {
   "description": "3-digit postcode area",
   "z_min": 1
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm2": {
   "description": "district",
   "z_min": 1
  }
 },
 "UG": {
  "adm1": {
   "description": "district",
   "z_min": 0
  },
  "bounds": [
   29.5722,
   -1.4873,
   35.0197,
   4.2267
  ],
  "feature_id": 15405287,
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm3": {
   "description": "sub-county",
   "z_min": 2
  },
  "adm2": {
   "description": "county",
   "z_min": 1
  }
 },
 "UM": {
  "adm1": {
   "description": "territory",
   "z_min": 3
  },
  "bounds": [
   -193.4023,
   -0.3805,
   -75.002,
   28.2186
  ],
  "feature_id": 15732968,
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  }
 },
 "UZ": {
  "adm1": {
   "description": "autonomous republic",
   "z_min": 0
  },
  "bounds": [
   55.9742,
   37.1818,
   73.1521,
   45.5821
  ],
  "feature_id": 15929579,
  "pos2": {
   "description": "2-digit postcode area",
   "z_min": 2
  },
  "pos3": {
   "description": "4-digit postcode area",
   "z_min": 2
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm2": {
   "description": "district",
   "z_min": 2
  }
 },
 "VC": {
  "adm1": {
   "description": "parish",
   "z_min": 5
  },
  "bounds": [
   -61.4609,
   12.5789,
   -61.1149,
   13.3832
  ],
  "feature_id": 12652781,
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  }
 },
 "VE": {
  "adm1": {
   "description": "state",
   "z_min": 0
  },
  "bounds": [
   -73.3529,
   0.6469,
   -59.8065,
   12.4912
  ],
  "feature_id": 16126190,
  "pos3": {
   "description": "2-digit postcode area",
   "z_min": 2
  },
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm2": {
   "description": "municipality",
   "z_min": 1
  }
 },
 "VU": {
  "adm1": {
   "description": "province",
   "z_min": 3
  },
  "bounds": [
   166.5414,
   -20.2532,
   170.2402,
   -13.0725
  ],
  "feature_id": 15995122,
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  }
 },
 "WF": {
  "adm1": {
   "description": "collectivity",
   "z_min": 3
  },
  "bounds": [
   -178.1824,
   -14.3622,
   -176.1242,
   -13.1828
  ],
  "feature_id": 16257267,
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  }
 },
 "YE": {
  "adm1": {
   "description": "governorate",
   "z_min": 0
  },
  "bounds": [
   41.9037,
   12.1081,
   54.5343,
   19
  ],
  "feature_id": 16388343,
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm2": {
   "description": "district",
   "z_min": 1
  }
 },
 "ZW": {
  "adm1": {
   "description": "province",
   "z_min": 0
  },
  "bounds": [
   25.2374,
   -22.422,
   33.054,
   -15.6099
  ],
  "feature_id": 16519419,
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "adm2": {
   "description": "town",
   "z_min": 1
  }
 },
 "AQ": {
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "bounds": [
   -180,
   -85.0511,
   180,
   -60.5155
  ],
  "feature_id": 528393
 },
 "KI": {
  "adm0": {
   "description": "country/territory",
   "z_min": 0
  },
  "bounds": [
   -190.4791,
   -11.4479,
   -150.1953,
   4.6994
  ],
  "feature_id": 7868534
 }
}